import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, DoBootstrap, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService, ConfigurationService } from '@niceltd/cxone-client-platform-services';
import { AccordionModule } from '@niceltd/cxone-components/accordion';
import { CheckboxModule } from '@niceltd/cxone-components/checkbox';
import { DateTimePickersModule } from '@niceltd/cxone-components/date-time-pickers';
import { EmbeddedMessagesModule } from '@niceltd/cxone-components/embedded-messages';
import { GridModule } from '@niceltd/cxone-components/grid';
import { ModalModule } from '@niceltd/cxone-components/modal';
import { MultiselectDropdownModule } from '@niceltd/cxone-components/multiselect-dropdown';
import { NumericSelectorModule } from '@niceltd/cxone-components/numeric-selector';
import { OmnibarModule } from '@niceltd/cxone-components/omnibar';
import { RadioModule } from '@niceltd/cxone-components/radio';
import { RangeSliderModule } from '@niceltd/cxone-components/range-slider';
import { SelectedTagsModule } from '@niceltd/cxone-components/selected-tags';
import { SingleselectDropdownModule } from '@niceltd/cxone-components/singleselect-dropdown';
import { SlideToggleModule } from '@niceltd/cxone-components/slide-toggle';
import { SpinnerModule } from '@niceltd/cxone-components/spinner';
import { SvgSpriteIconModule } from '@niceltd/cxone-components/svg-sprite-icon';
import { TabsModule } from '@niceltd/cxone-components/tabs';
import { TagifyModule } from '@niceltd/cxone-components/tagify';
import { TextAreaModule } from '@niceltd/cxone-components/text-area';
import { TextInputModule } from '@niceltd/cxone-components/text-input';
import { ToastrManagerModule } from '@niceltd/cxone-components/toastr';
import { ToggleButtonGroupModule } from '@niceltd/cxone-components/toggle-button-group';
import { ConfigurationService as ConfigurationCoreService, DynamicLocaleId, LocalizationInitializer } from '@niceltd/cxone-core-services';
import { AddEntityModule } from '@niceltd/cxone-domain-components/add-entity';
import { ButtonModule as ButtonSolModule } from "@niceltd/sol/button";
import { CardModule as SolCardModule } from "@niceltd/sol/card";
import { CheckboxModule as CheckboxSolModule } from '@niceltd/sol/checkbox';
import { ChipModule as SolChipModule } from "@niceltd/sol/chip";
import { DateRangepickerModule } from "@niceltd/sol/date-range-picker";
import { DatepickerModule, DatepickerModule as DatepickerSolModule } from '@niceltd/sol/datepicker';
import { DropdownModule, DropdownModule as DropdownSolModule } from '@niceltd/sol/dropdown';
import { FloatingMenuModule } from '@niceltd/sol/floating-menu';
import { GridModule as GridSolModule } from "@niceltd/sol/grid";
import { InlineNotificationModule } from '@niceltd/sol/inline-notification';
import { NumericSelectorModule as NumericSelectorSolModule } from "@niceltd/sol/numeric-selector";
import { OmnibarModule as OmnibarSolModule } from '@niceltd/sol/omnibar';
import { RadioModule as RadioSolModule } from "@niceltd/sol/radio-button";
import { SelectedTagsModule as SelectedTagsSolModule } from '@niceltd/sol/selected-tags';
import { SlideToggleModule as SlideToggleSolModule } from '@niceltd/sol/slide-toggle';
import { StatusIndicatorModule as SolStatusIndicatorModule } from "@niceltd/sol/status-indicator";
import { TabsModule as SolTabsModule } from "@niceltd/sol/tabs";
import { TextInputModule as SolTextInput } from "@niceltd/sol/text-input";
import { ToastrManagerModule as ToastrManagerSolModule } from "@niceltd/sol/toastr";
import { ButtonToggleGroupModule as SolButtonToggleGroupModule } from "@niceltd/sol/toggle-group";
import { TooltipModule as SolTooltipModule } from "@niceltd/sol/tooltip";
import { EditorModule } from '@tinymce/tinymce-angular';
import { AgGridModule } from 'ag-grid-angular';
import { GridsterModule } from 'angular-gridster2';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { HighchartsChartModule } from 'highcharts-angular';
import { InitOptions, LanguageDetectorModule } from 'i18next';
import { NgChartsModule } from 'ng2-charts';
import { NouisliderModule } from 'ng2-nouislider';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ImageCropperModule } from 'ngx-image-cropper';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { ColorPickerModule } from "primeng/colorpicker";
import { CxoneColumnHeaderRendererComponent } from 'src/app/cxone/admin/cxone-manage-metrics/ag-grid-components/cxone-column-header-renderer/cxone-column-header-renderer.component';
import { CxoneMetricNameCellRendererComponent } from 'src/app/cxone/admin/cxone-manage-metrics/ag-grid-components/cxone-metric-name-cell-renderer/cxone-metric-name-cell-renderer.component';
import { AssociatedMetricsComponent } from 'src/app/cxone/admin/cxone-manage-metrics/associated-metrics/associated-metrics.component';
import { ContextMenuCellRendererComponent } from 'src/app/cxone/admin/cxone-manage-metrics/context-menu-cell-renderer/context-menu-cell-renderer.component';
import { CxoneManageMetricsComponent } from 'src/app/cxone/admin/cxone-manage-metrics/cxone-manage-metrics.component';
import { FilterFieldsEditComponent } from 'src/app/cxone/admin/cxone-manage-metrics/filter-fields-edit/filter-fields-edit.component';
import { CxoneContextMenuCellRendererComponent } from 'src/app/cxone/admin/cxone-objectives/context-menu-cell-renderer/context-menu-cell-renderer.component';
import { CustomTooltipCellRendererComponent } from 'src/app/cxone/admin/cxone-objectives/custom-tooltip-cell-renderer/custom-tooltip-cell-renderer.component';
import { CxoneObjectivesComponent } from 'src/app/cxone/admin/cxone-objectives/cxone-objectives.component';
import { EmptyObjectivesTabComponent } from 'src/app/cxone/admin/cxone-objectives/empty-objectives-tab/empty-objectives-tab.component';
import { NotificationEditCellRendererComponent } from 'src/app/cxone/admin/cxone-objectives/notification-edit-cell-renderer/notification-edit-cell-renderer.component';
import { CVLocalizedTextDirective } from 'src/app/reusables/localization/cv-localized-text.directive';
import { AgGridGroupHeaderTooltipComponent } from 'src/shared/ag-grid-components/ag-grid-group-header-tooltip/ag-grid-group-header-tooltip.component';
import { createNg1Wrapper } from 'src/shared/create_ng1_wrapper';
import { GenericExportComponent } from 'src/shared/generic-export/generic-export.component';
import { AngularModuleServiceBase } from 'src/shared/services/angular-module-service-base';
import { AboutComponent } from './about/about.component';
import { CompanyEditSsoComponent } from './admin/company-settings/company-edit-sso/company-edit-sso.component';
import { CompanySettingsComponent } from './admin/company-settings/company-settings.component';
import { CXOneFirstPhaseIntegrationComponent } from './admin/cxone-first-phase-integration/cxone-first-phase-integration.component';
import { LaunchWallboardComponent } from './admin/launch-wallboard/launch-wallboard.component';
import { ObjectiveAddEditComponent } from './admin/objectives/objective-add-edit/objective-add-edit.component';
import { ObjectiveAssignComponent } from './admin/objectives/objective-assign/objective-assign.component';
import { ObjectiveGroupsAssignedComponent } from './admin/objectives/objective-groups-assigned/objective-groups-assigned.component';
import { ObjectiveGroupsCardViewComponent } from './admin/objectives/objective-groups-card-view/objective-groups-card-view.component';
import { ObjectiveLandingComponent } from './admin/objectives/objective-landing/objective-landing.component';
import { ObjectiveMetricsAssignedComponent } from './admin/objectives/objective-metrics-assigned/objective-metrics-assigned.component';
import { ObjectiveTimePipe } from './admin/objectives/objective-time.pipe';
import { UsageStatsExportButtonComponent } from './admin/usage-stats-export-button/usage-stats-export-button.component';
import { AccessUseradminComponent } from './admin/user/access-useradmin/access-useradmin.component';
import { PageAccessCellRenderer } from './admin/user/access-useradmin/page-access-cell/page-access-cell.component';
import { WidgetAccessCellRendererComponent } from './admin/user/access-useradmin/widget-access-cell-renderer/widget-access-cell-renderer.component';
import { AddUserComponent } from './admin/user/add-user/add-user.component';
import { AttributesUseradminComponent } from './admin/user/attributes-useradmin/attributes-useradmin.component';
import { DashboardsUseradminComponent } from './admin/user/dashboards-useradmin/dashboards-useradmin.component';
import { DetailsUseradminComponent } from './admin/user/details-useradmin/details-useradmin.component';
import { GamificationDetailPageComponent } from './admin/user/gamification-detail-page/gamification-detail-page.component';
import { GamificationPageComponent } from './admin/user/gamification-page/gamification-page.component';
import { ImageUploadComponent } from './admin/user/image-upload/image-upload.component';
import { PackagesUseradminComponent } from './admin/user/packages-useradmin/packages-useradmin.component';
import { PermissionAssignBoxComponent } from './admin/user/permission-assign-box/permission-assign-box.component';
import { PermissionsUseradminComponent } from './admin/user/permissions-useradmin/permissions-useradmin.component';
import { SelectedUserLabelComponent } from './admin/user/selected-user-label/selected-user-label.component';
import { UserAdminComponent } from './admin/user/user-admin/user-admin.component';
import { UserListComponent } from './admin/user/user-list/user-list.component';
import { AnnouncementsNewComponent } from './announcements/announcements-new/announcements-new.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { CxoneCustomDataImportDialogComponent } from './cxone/admin/cxone-custom-data-import/components/cxone-custom-data-import-dialog/cxone-custom-data-import-dialog.component';
import { CxoneCustomDataImportViewComponent } from './cxone/admin/cxone-custom-data-import/components/cxone-custom-data-import-view/cxone-custom-data-import-view.component';
import { CxoneCustomDataImportComponent } from './cxone/admin/cxone-custom-data-import/cxone-custom-data-import.component';
import { ImportActionCellComponent } from './cxone/admin/cxone-custom-data-import/import-action-cell/import-action-cell.component';
import { DataFeedActionsCellRendererComponent } from './cxone/admin/cxone-etl-data-feed/actions-cell/data-feed-actions-cell-renderer.component';
import { ActionRendererComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/action-renderer/action-renderer.component';
import { ActiveRendererComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/active-renderer/active-renderer.component';
import { DataTypeRendererComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/data-type-renderer/data-type-renderer.component';
import { FieldNameRendererComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/field-name-renderer/field-name-renderer.component';
import { PrimaryKeyHeaderComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/primary-key-header/primary-key-header.component';
import { PrimaryKeyRendererComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cell-renderers/primary-key-renderer/primary-key-renderer.component';
import { CreateEditEtlDataFeedComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/create-edit-data-feed.component';
import { CxoneEtlLoadFromFileComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cxone-etl-load-from-file/cxone-etl-load-from-file.component';
import { LoadFromFileTreeComponent } from './cxone/admin/cxone-etl-data-feed/create-edit-data-feed/cxone-etl-load-from-file/load-from-file-tree/load-from-file-tree.component';
import { CxoneEtlDataFeedDependenciesComponent } from './cxone/admin/cxone-etl-data-feed/cxone-etl-data-feed-dependencies/cxone-etl-data-feed-dependencies.component';
import { CxoneEtlDataFeedViewComponent } from './cxone/admin/cxone-etl-data-feed/cxone-etl-data-feed-view/cxone-etl-data-feed-view.component';
import { CxoneEtlDataFeedComponent } from './cxone/admin/cxone-etl-data-feed/cxone-etl-data-feed.component';
import { CxoneEtlDataRecalculationComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-data-recalculation/cxone-etl-data-recalculation.component';
import { StatusCellRendererComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-data-recalculation/status-cell-renderer/status-cell-renderer.component';
import { CxoneEtlRecalculationModalComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-recalculation-modal/cxone-etl-recalculation-modal.component';
import { CxoneRecalculationMetricViewComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-recalculation-modal/cxone-recalculation-metric-view/cxone-recalculation-metric-view.component';
import { CxoneRecalculationReportingSetViewComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-recalculation-modal/cxone-recalculation-reporting-set-view/cxone-recalculation-reporting-set-view.component';
import { MetricDetailedViewComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-recalculation-modal/metric-detailed-view/metric-detailed-view.component';
import { ReportingSetDetailedViewComponent } from './cxone/admin/cxone-etl-recalculation/cxone-etl-recalculation-modal/reporting-set-detailed-view/reporting-set-detailed-view.component';
import { AddSimpleFeedModalComponent } from './cxone/admin/cxone-etl-reporting-set/components/add-simple-feed-modal/add-simple-feed-modal.component';
import { CxoneEtlReportingSetJoinedFeedComponent } from './cxone/admin/cxone-etl-reporting-set/components/cxone-etl-reporting-set-joined-feed/cxone-etl-reporting-set-joined-feed.component';
import { CxoneReportingSetCreateEditComponent } from './cxone/admin/cxone-etl-reporting-set/components/cxone-reporting-set-create-edit/cxone-reporting-set-create-edit.component';
import { CxoneReportingSetDataFieldComponent } from "./cxone/admin/cxone-etl-reporting-set/components/cxone-reporting-set-data-field/cxone-reporting-set-data-field.component";
import { ContactGroupComponent } from './cxone/admin/cxone-etl-reporting-set/components/cxone-reporting-set-flow-builder/contact-group/contact-group.component';
import { CxoneReportingSetFlowBuilderComponent } from './cxone/admin/cxone-etl-reporting-set/components/cxone-reporting-set-flow-builder/cxone-reporting-set-flow-builder.component';
import { EmployeeGroupComponent } from './cxone/admin/cxone-etl-reporting-set/components/cxone-reporting-set-flow-builder/employee-group/employee-group.component';
import { DeleteRowRenderer } from './cxone/admin/cxone-etl-reporting-set/components/delete-row-renderer/delete-row-renderer.component';
import { DrawLinesComponent } from './cxone/admin/cxone-etl-reporting-set/components/draw-line-components/draw-lines/draw-lines.component';
import { LineAnchorDirective } from './cxone/admin/cxone-etl-reporting-set/components/draw-line-components/draw-lines/line-anchor.directive';
import { ResizeDirective } from './cxone/admin/cxone-etl-reporting-set/components/draw-line-components/draw-lines/resize.directive';
import { CxoneReportingSetComplexNumericFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/complex-numeric-field/complex-numeric-field.component';
import { FunctionOperatorFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/complex-numeric-field/function-operator-field/function-operator-field.component';
import { CxoneReportingSetCoalesceFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-coalesce-field/cxone-reporting-set-coalesce-field.component';
import { CxoneReportingSetComplexDateFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-complex-date-field/cxone-reporting-set-complex-date-field.component';
import { CxoneReportingSetComplexStringFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-complex-string-field/complex-string-field.component';
import { ComparisonFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-conditional-field/comparison-field/comparison-field.component';
import { CxoneReportingSetConditionalFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-conditional-field/cxone-reporting-set-conditional-field.component';
import { CxoneReportingSetRegexFieldComponent } from './cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-regex-field/cxone-reporting-set-regex-field.component';
import { CxoneReportingSetSimpleFieldComponent } from "./cxone/admin/cxone-etl-reporting-set/components/field-types/cxone-reporting-set-simple-field/cxone-reporting-set-simple-field.component";
import { CxoneReportingSetSubstringFieldComponent } from "./cxone/admin/cxone-etl-reporting-set/components/field-types/substring-field/substring-field.component";
import { TreeBuilderComponent } from './cxone/admin/cxone-etl-reporting-set/components/tree-builder/tree-builder.component';
import { CxoneEtlReportingSetDependenciesComponent } from './cxone/admin/cxone-etl-reporting-set/cxone-etl-reporting-set-dependencies/cxone-etl-reporting-set-dependencies.component';
import { CxoneEtlReportingSetComponent } from './cxone/admin/cxone-etl-reporting-set/cxone-etl-reporting-set.component';
import { ReportingSetActionsCellComponent } from './cxone/admin/cxone-etl-reporting-set/reporting-set-actions-cell/reporting-set-actions-cell.component';
import { LockIconCellRendererComponent } from './cxone/admin/cxone-manage-metrics/ag-grid-components/lock-icon-cell-renderer.component';
import { ManageMetricsRecalculationDetailsModalComponent } from './cxone/admin/cxone-manage-metrics/manage-metrics-recalculation-details-modal/manage-metrics-recalculation-details-modal.component';
import { ManageMetricsRecalculationModalComponent } from './cxone/admin/cxone-manage-metrics/manage-metrics-recalculation-modal/manage-metrics-recalculation-modal.component';
import { CustomNoRowsOverlayComponent } from './cxone/admin/shared/custom-no-rows-overlay/custom-no-rows-overlay.component';
import { EmbeddedMessagesComponent } from './cxone/admin/shared/embedded-messages/embedded-messages.component';
import { EtlCustomCellValueRendererComponent } from './cxone/admin/shared/etl-custom-cell-value-renderer/etl-custom-cell-value-renderer.component';
import { FailedImportReportComponent } from './cxone/admin/shared/failed-import-report/failed-import-report.component';
import { ViewReasonModalComponent } from './cxone/admin/shared/view-reason-modal/view-reason-modal.component';
import { CSMInnerRenderer, CategorySelectionModalComponent } from './cxone/dashboard/modals/category-selection-modal/category-selection-modal.component';
import { CategoryOverTimeSettingsComponent } from './cxone/dashboard/module-settings/category-over-time-settings/category-over-time-settings.component';
import { CxoneCallArrivalSettingsComponent } from './cxone/dashboard/module-settings/cxone-call-arrival-settings/cxone-call-arrival-settings.component';
import { CXoneEvaluationCoachingTrendSettingsComponent } from './cxone/dashboard/module-settings/cxone-evaluation-coaching-trend-settings/cxone-evaluation-coaching-trend-settings.component';
import { EvaluatorCalibrationSettingsComponent } from './cxone/dashboard/module-settings/evaluator-calibration-settings/evaluator-calibration-settings.component';
import { FormsCalibrationSettingsComponent } from './cxone/dashboard/module-settings/forms-calibration-settings/forms-calibration-settings.component';
import { IaFrustrationSettingsComponent } from './cxone/dashboard/module-settings/ia-frustration-settings/ia-frustration-settings.component';
import { PlansStatusSettingsComponent } from './cxone/dashboard/module-settings/plans-status-settings/plans-status-settings.component';
import { QmEvaluationsCoachingSettingsComponent } from './cxone/dashboard/module-settings/qm-evaluations-coaching-settings/qm-evaluations-coaching-settings.component';
import { QmEvaluatorPerformanceSettingsComponent } from './cxone/dashboard/module-settings/qm-evaluator-performance-settings/qm-evaluator-performance-settings.component';
import { QualityScoreSettingsComponent } from './cxone/dashboard/module-settings/quality-score-settings/quality-score-settings.component';
import { ReportSettingsComponent } from './cxone/dashboard/module-settings/report-settings/report-settings.component';
import { TopCategoriesSettingsComponent } from './cxone/dashboard/module-settings/top-categories-settings/top-categories-settings.component';
import { CXOneCallArrivalComponent } from './cxone/dashboard/modules/call-arrival/cxone-call-arrival.component';
import { CategoryOverTimeComponent } from './cxone/dashboard/modules/category-over-time/category-over-time.component';
import { CxoneNewCategoryWindowComponent } from './cxone/dashboard/modules/category-over-time/cxone-new-category-window/cxone-new-category-window.component';
import { CoachingStatusComponent } from './cxone/dashboard/modules/coaching-status/coaching-status.component';
import { CxoneDispositionsComponent } from './cxone/dashboard/modules/cxone-dispositions/cxone-dispositions.component';
import { CxoneEvaluationCoachingTrendComponent } from './cxone/dashboard/modules/cxone-evaluation-coaching-trend/cxone-evaluation-coaching-trend.component';
import { CxoneAgentCardComponent } from './cxone/dashboard/modules/cxone-games-tracker/cxone-agent-card/cxone-agent-card.component';
import { CxoneGamesTrackerComponent } from './cxone/dashboard/modules/cxone-games-tracker/cxone-games-tracker.component';
import { CxoneSeeMoreComponent } from './cxone/dashboard/modules/cxone-games-tracker/cxone-see-more/cxone-see-more.component';
import { CxoneKpiTrendComponent } from './cxone/dashboard/modules/cxone-kpi-trend/cxone-kpi-trend.component';
import { EvaluatorCalibrationComponent } from './cxone/dashboard/modules/evaluator-calibration/evaluator-calibration.component';
import { FormsCalibrationComponent } from './cxone/dashboard/modules/forms-calibration/forms-calibration.component';
import { GaugeComponent as CXoneGaugeComponent } from './cxone/dashboard/modules/gauge/gauge.component';
import { IaFrustrationComponent } from './cxone/dashboard/modules/ia-frustration/ia-frustration.component';
import { KpiTrendCoachingEventsComponent } from './cxone/dashboard/modules/kpi-trend-coaching-events/kpi-trend-coaching-events.component';
import { KpiTrendCoachingHeaderComponent } from './cxone/dashboard/modules/kpi-trend-coaching-events/kpi-trend-coaching-header/kpi-trend-coaching-header.component';
import { MetricsBreakDownComponent } from './cxone/dashboard/modules/metrics-breakdown/metrics-breakdown.component';
import { PlansStatusComponent } from './cxone/dashboard/modules/plans-status/plans-status.component';
import { QmEvaluationsCoachingComponent } from './cxone/dashboard/modules/qm-evaluations-coaching/qm-evaluations-coaching.component';
import { QmEvaluatorPerformanceComparisonComponent } from './cxone/dashboard/modules/qm-evaluator-performance/qm-evaluator-performance-comparison/qm-evaluator-performance-comparison.component';
import { QmEvaluatorPerformanceTrendComponent } from './cxone/dashboard/modules/qm-evaluator-performance/qm-evaluator-performance-trend/qm-evaluator-performance-trend.component';
import { QmEvaluatorPerformanceComponent } from './cxone/dashboard/modules/qm-evaluator-performance/qm-evaluator-performance.component';
import { QualityScoreGridCustomHeaderComponent } from './cxone/dashboard/modules/quality-score/quality-score-grid-custom-header/quality-score-grid-custom-header.component';
import { QualityScoreMetricCellRendererComponent } from './cxone/dashboard/modules/quality-score/quality-score-metric-cell-renderer/quality-score-metric-cell-renderer.component';
import { QualityScoreUserCellRendererComponent } from './cxone/dashboard/modules/quality-score/quality-score-user-cell-renderer/quality-score-user-cell-renderer.component';
import { QualityScoreComponent } from './cxone/dashboard/modules/quality-score/quality-score.component';
import { ChannelTypeCellRendererComponent } from './cxone/dashboard/modules/report/channel-type-cell-renderer/channel-type-cell-renderer.component';
import { CxonePlayIconCellComponent } from './cxone/dashboard/modules/report/cxone-play-icon-cell/cxone-play-icon-cell.component';
import { ReportComponent } from './cxone/dashboard/modules/report/report.component';
import { TopCategoriesComponent } from './cxone/dashboard/modules/top-categories/top-categories.component';
import { CoachingTypeFilterComponent } from './cxone/dashboard/toolbar-items/coaching-type-filter/coaching-type-filter.component';
import { CxoneIntervalSelectorComponent } from './cxone/dashboard/toolbar-items/cxone-interval-selector/cxone-interval-selector.component';
import { CxonePopoutComponent } from './cxone/dashboard/toolbar-items/cxone-popout/cxone-popout.component';
import { CxoneTeamsComponent } from './cxone/dashboard/toolbar-items/cxone-teams/cxone-teams.component';
import { FrustrationModeSelectorComponent } from './cxone/dashboard/toolbar-items/frustration-mode-selector/frustration-mode-selector.component';
import { AwardCardComponent } from './dashboard/awards/award-card/award-card.component';
import { ContextMenuAwardsDialogComponent } from './dashboard/awards/context-menu-awards-dialog/context-menu-awards-dialog.component';
import { CXOneAddWidgetComponent } from './dashboard/cxone-dashboard/cxone-add-widget/cxone-add-widget.component';
import { CxoneAttributeSelectorComponent } from './dashboard/cxone-dashboard/cxone-attribute-selector/cxone-attribute-selector.component';
import { RepeatedSelectorsComponent } from './dashboard/cxone-dashboard/cxone-attribute-selector/repeated-selectors/repeated-selectors.component';
import { CxoneContactStateDescriptionsSelectorComponent } from './dashboard/cxone-dashboard/cxone-contact-state-descriptions-selector/cxone-contact-state-descriptions-selector.component';
import { CxoneDashboardContentComponent } from './dashboard/cxone-dashboard/cxone-dashboard-content/cxone-dashboard-content.component';
import { CxoneDashboardFilterComponent } from './dashboard/cxone-dashboard/cxone-dashboard-filter/cxone-dashboard-filter.component';
import { CxoneDateRangeSelectorComponent } from './dashboard/cxone-dashboard/cxone-date-range-selector/cxone-date-range-selector.component';
import { CxoneEmptyWorkspaceComponent } from './dashboard/cxone-dashboard/cxone-empty-workspace/cxone-empty-workspace.component';
import { CxoneModuleSettingsModalComponent } from './dashboard/cxone-dashboard/cxone-module-settings-modal/cxone-module-settings-modal.component';
import { CXOneDashboardHeaderComponent } from './dashboard/cxone-dashboard/dashboard-header/dashboard-header.component';
import { GainsightInjectorComponent } from './dashboard/cxone-dashboard/gainsight-injector/gainsight-injector.component';
import { CxoneSelectAwardCardComponent } from './dashboard/cxone-select-award-card/cxone-select-award-card.component';
import { DashboardFilterSlideoutComponent } from './dashboard/dashboard-filter-slideout/dashboard-filter-slideout.component';
import { DashboardWindowComponent } from './dashboard/dashboard-window/dashboard-window.component';
import { LaunchCXOneDashAdminComponent } from './dashboard/launch-cxone-dash-admin/launch-cxone-dash-admin.component';
import { AgentStateDetailComponent } from './dashboard/modals/agent-state-detail/agent-state-detail.component';
import { AgentStatesColorModalComponent } from './dashboard/modals/agent-states-color-modal/agent-states-color-modal.component';
import { CreateNewReportModalComponent } from './dashboard/modals/create-new-report-modal/create-new-report-modal.component';
import { CxoneAwardModalComponent } from './dashboard/modals/cxone-award-modal/cxone-award-modal.component';
import { DashboardAccessComponent } from './dashboard/modals/dashboard-access/dashboard-access.component';
import { PermissionCellRendererComponent } from './dashboard/modals/dashboard-access/permission-cell-renderer/permission-cell-renderer.component';
import { DeleteSubscriptionComponent } from './dashboard/modals/delete-subscription/delete-subscription.component';
import { SaveDashboardModalComponent } from './dashboard/modals/save-dashboard-modal/save-dashboard-modal.component';
import { SendToSubscriptionComponent } from './dashboard/modals/send-to-subscription/send-to-subscription.component';
import { ShareViaUrlComponent } from './dashboard/modals/share-via-url/share-via-url.component';
import { SubscriptionModalComponent } from './dashboard/modals/subscription-modal/subscription-modal.component';
import { TakeOwnershipComponent } from './dashboard/modals/take-ownership/take-ownership.component';
import { TasksModalComponent } from './dashboard/modals/tasks-modal/tasks-modal.component';
import { TemplateListModalComponent } from './dashboard/modals/template-list-modal/template-list-modal.component';
import { ThresholdRangeValidator } from './dashboard/modals/widget-thresholds-modal/threshold-range-validator.component';
import { WidgetThresholdsModalComponent } from './dashboard/modals/widget-thresholds-modal/widget-thresholds-modal.component';
import { ModuleContainerComponent } from './dashboard/module-container/module-container.component';
import { ModuleCustomSettingSectionComponent } from './dashboard/module-custom-setting-section/module-custom-setting-section.component';
import { ModuleCxoneCustomSettingSectionDirective } from './dashboard/module-custom-setting-section/module-cxone-custom-setting-section.directive';
import { ModuleLegacyCustomSettingSectionDirective } from './dashboard/module-custom-setting-section/module-legacy-custom-setting-section.directive';
import { ModuleErrorComponent } from './dashboard/module-error/module-error.component';
import { ModulePreviewComponent } from './dashboard/module-preview/module-preview.component';
import { AgentCounterSettingsComponent } from './dashboard/module-settings/agent-counter-settings/agent-counter-settings.component';
import { CalculatedMetricBreakdownSettingsComponent } from './dashboard/module-settings/calculated-metric-breakdown-settings/calculated-metric-breakdown-settings.component';
import { CallArrivalSettingsComponent } from './dashboard/module-settings/call-arrival-settings/call-arrival-settings.component';
import { ContactListSettingsComponent } from './dashboard/module-settings/contact-list-settings/contact-list-settings.component';
import { ContactStatesSkillSettingsComponent } from './dashboard/module-settings/contact-states-skill-settings/contact-states-skill-settings.component';
import { CurrentAgentStatesSettingsComponent } from './dashboard/module-settings/current-agent-states-settings/current-agent-states-settings.component';
import { ExpandedSummarySettingsComponent } from './dashboard/module-settings/expanded-summary-settings/expanded-summary-settings.component';
import { IntervalComboSettingsComponent } from './dashboard/module-settings/interval-combo-settings/interval-combo-settings.component';
import { NgTemplateSettingsComponent } from './dashboard/module-settings/ng-template-settings/ng-template-settings.component';
import { QueueCounterSettingsComponent } from './dashboard/module-settings/queue-counter-settings/queue-counter-settings.component';
import { ReportingSetSettingsComponent } from './dashboard/module-settings/reporting-set-settings/reporting-set-settings.component';
import { TopCallTimesSettingsComponent } from './dashboard/module-settings/top-call-times-settings/top-call-times-settings.component';
import { WebhelpETSSettingsComponent } from './dashboard/module-settings/webhelp-ets-settings/webhelp-ets-settings.component';
import { AcdCallbackComponent } from './dashboard/modules/acd-callback/acd-callback.component';
import { AgGridIChartTemplateComponent } from './dashboard/modules/ag-grid-ichart-template/ag-grid-ichart-template.component';
import { AgentCounterComponent } from './dashboard/modules/agent-counter/agent-counter.component';
import { CalculatedMetricBreakdownComponent } from './dashboard/modules/calculated-metric-breakdown/calculated-metric-breakdown.component';
import { CalculatedMetricBreakdownFormulaComponent } from './dashboard/modules/calculated-metric-breakdown/formula-renderer/calculated-metric-breakdown-formula/calculated-metric-breakdown-formula.component';
import { CalculatorComponent } from './dashboard/modules/calculator/calculator.component';
import { CallArrivalComponent } from './dashboard/modules/call-arrival/call-arrival.component';
import { ContactListDetailsComponent } from './dashboard/modules/contact-list/contact-list-details/contact-list-details.component';
import { ContactStateCellRendererComponent } from './dashboard/modules/contact-list/contact-list-details/contact-state-cell-renderer/contact-state-cell-renderer.component';
import { ContactListImageCellRendererComponent } from './dashboard/modules/contact-list/contact-list-image-cell-renderer/contact-list-image-cell-renderer.component';
import { ContactListComponent } from './dashboard/modules/contact-list/contact-list.component';
import { CurrentAgentStatesCxoneGraphComponent } from './dashboard/modules/current-agent-states/current-agent-states-cxone/current-agent-states-cxone-graph/current-agent-states-cxone-graph.component';
import { CurrentAgentStatesCxoneTableComponent } from './dashboard/modules/current-agent-states/current-agent-states-cxone/current-agent-states-cxone-table/current-agent-states-cxone-table.component';
import { CurrentAgentStatesCxoneComponent } from './dashboard/modules/current-agent-states/current-agent-states-cxone/current-agent-states-cxone.component';
import { CurrentAgentStatesPmGraphComponent } from './dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm-graph/current-agent-states-pm-graph.component';
import { CurrentAgentStatesPmTableComponent } from './dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm-table/current-agent-states-pm-table.component';
import { CurrentAgentStatesPmComponent } from './dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm.component';
import { CurrentAgentStatesComponent } from './dashboard/modules/current-agent-states/current-agent-states.component';
import { CxoneGameCardComponent } from './dashboard/modules/cxone-games/cxone-game-card/cxone-game-card.component';
import { CxoneGameMultiplierMadnessComponent } from './dashboard/modules/cxone-games/cxone-game-multiplier-madness/cxone-game-multiplier-madness.component';
import { CxoneGameQualifierComponent } from './dashboard/modules/cxone-games/cxone-game-qualifier/cxone-game-qualifier.component';
import { CxoneGameTopTeamComponent } from './dashboard/modules/cxone-games/cxone-game-top-team/cxone-game-top-team.component';
import { CxoneBullseyeGameComponent } from './dashboard/modules/cxone-games/cxone-games-bullseye/cxone-games-bullseye.component';
import { CxoneGamesMilestoneComponent } from './dashboard/modules/cxone-games/cxone-games-milestone/cxone-games-milestone.component';
import { CxoneGamesComponent } from './dashboard/modules/cxone-games/cxone-games.component';
import { CxoneMyRankingComponent } from './dashboard/modules/cxone-my-ranking/cxone-my-ranking.component';
import { ExpandedSummaryComponent } from './dashboard/modules/expanded-summary/expanded-summary.component';
import { ExtendedKpiItemComponent } from './dashboard/modules/extended-kpi-item/extended-kpi-item.component';
import { ExtendedKpiComponent } from './dashboard/modules/extended-kpi/extended-kpi.component';
import { GaugeComponent as CVGaugeComponent } from './dashboard/modules/gauge/gauge.component';
import { HeatmapComponent } from './dashboard/modules/heatmap/heatmap.component';
import { IntervalComboComponent } from './dashboard/modules/interval-combo/interval-combo.component';
import { KpiComponent } from './dashboard/modules/kpi/kpi.component';
import { LeaderboardMyMetricComponent } from './dashboard/modules/leaderboard/leaderboard-my-metric/leaderboard-my-metric.component';
import { LeaderboardRankCellRendererComponent } from './dashboard/modules/leaderboard/leaderboard-rank-cell-renderer/leaderboard-rank-cell-renderer.component';
import { LeaderboardComponent } from './dashboard/modules/leaderboard/leaderboard.component';
import { LinkedContactsDetailsComponent } from './dashboard/modules/linked-contacts/linked-contacts-details/linked-contacts-details.component';
import { LinkedContactsComponent } from './dashboard/modules/linked-contacts/linked-contacts.component';
import { LoginLogoutComponent } from './dashboard/modules/login-logout/login-logout.component';
import { MetricReviewComponent } from './dashboard/modules/metric-review/metric-review.component';
import { MyRankingComponent } from './dashboard/modules/my-ranking/my-ranking.component';
import { MyRankingCardComponent } from './dashboard/modules/cxone-my-ranking/my-ranking-card/my-ranking-card.component';
import { NgTemplateComponent } from './dashboard/modules/ng-template/ng-template.component';
import { NotepadComponent } from './dashboard/modules/notepad/notepad.component';
import { QueueCounterComponent } from './dashboard/modules/queue-counter/queue-counter.component';
import { ReportingSetComponent } from './dashboard/modules/reporting-set/reporting-set.component';
import { ServiceLevelComponent } from './dashboard/modules/service-level/service-level.component';
import { SummaryComboComponent } from './dashboard/modules/summary-combo/summary-combo.component';
import { TasksComponent } from './dashboard/modules/tasks/tasks.component';
import { TopCallTimesComponent } from './dashboard/modules/top-call-times/top-call-times.component';
import { TrendingComponent } from './dashboard/modules/trending/trending.component';
import { WebhelpETSComponent } from './dashboard/modules/webhelp-ets/webhelp-ets.component';
import { DashboardProjectionContentComponent } from './dashboard/projection/dashboard-projection-content/dashboard-projection-content.component';
import { ResponsiveDashboardComponent } from './dashboard/responsive-dashboard/responsive-dashboard.component';
import { SharedDashboardComponent } from './dashboard/shared-dashboard/shared-dashboard.component';
import { SidebarModuleListComponent } from './dashboard/sidebar-module-list/sidebar-module-list.component';
import { TaskbarComponent } from './dashboard/taskbar/taskbar.component';
import { ActionsCellRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/actions-cell-renderer/actions-cell-renderer.component';
import { CxoneDashboardNameCellRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/cxone-dashboard-name-cell-renderer/cxone-dashboard-name-cell-renderer.component';
import { DashboardNameRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/dashboard-name-renderer/dashboard-name-renderer.component';
import { DescriptionCellRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/description-renderer/description-renderer.component';
import { FavoriteButtonRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/favorite-button-renderer/favorite-button-renderer.component';
import { OwnerCellRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/owner-cell-renderer/owner-cell-renderer.component';
import { ShareTextRendererComponent } from './dashboard/workspace/manage-available-dashboards/ag-grid-components/share-text-renderer/share-text-renderer/share-text-renderer.component';
import { ManageAvailableDashboardsComponent } from './dashboard/workspace/manage-available-dashboards/manage-available-dashboards.component';
import { SelectedDashboardDetailsComponent } from './dashboard/workspace/selected-dashboard-details/selected-dashboard-details.component';
import { CreateNewDashboardComponent } from './dashboard/workspace/workspace-new-tab/create-new-dashboard/create-new-dashboard.component';
import { NewSystemTemplateComponent } from './dashboard/workspace/workspace-new-tab/new-system-template/new-system-template.component';
import { OpenExistingDashboardComponent } from './dashboard/workspace/workspace-new-tab/open-existing-dashboard/open-existing-dashboard.component';
import { OpenExistingTemplateComponent } from './dashboard/workspace/workspace-new-tab/open-existing-template/open-existing-template.component';
import { WorkspaceNewTabLandingComponent } from './dashboard/workspace/workspace-new-tab/workspace-new-tab-landing/workspace-new-tab-landing.component';
import { FormsAssignComponent } from './forms/forms-assign/forms-assign.component';
import { FormsComponent } from './forms/forms.component';
import { AwardedPopupComponent } from './gamification/command-center/components/awards/awarded-popup/awarded-popup.component';
import { AwardsAddEditComponent } from './gamification/command-center/components/awards/awards-add-edit/awards-add-edit.component';
import { AwardsCardMenuComponent } from './gamification/command-center/components/awards/awards-card-menu/awards-card-menu.component';
import { AwardsLandingComponent } from './gamification/command-center/components/awards/awards-landing/awards-landing.component';
import { GiveAwardPopupComponent } from './gamification/command-center/components/awards/give-award-popup/give-award-popup.component';
import { AwardsExportButtonComponent } from './gamification/command-center/components/awards/view-history/awards-export-button/awards-export-button.component';
import { AwardsFilterPipe } from './gamification/command-center/custom-pipes/award-name-filter.pipe';
import { AwardsHistoryListComponent } from './gamification/command-center/components/awards/view-history/awards-history-list/awards-history-list.component';
import { BudgetExportButtonComponent } from './gamification/command-center/components/budget/budget-history/budget-export-button/budget-export-button.component';
import { ChallengedUsersModalComponent } from './gamification/command-center/components/challenges/challenged-users-modal/challenged-users-modal.component';
import { ChallengesHistoryComponent } from './gamification/command-center/components/challenges/challenges-history/challenges-history.component';
import { ChallengesListComponent } from './gamification/command-center/components/challenges/challenges-list/challenges-list.component';
import { ChallengesSettingsComponent } from './gamification/command-center/components/challenges/challenges-settings/challenges-settings.component';
import { CurrencyPendingExportButtonComponent } from './gamification/command-center/components/currency/currency-pending/currency-pending-export-button/currency-pending-export-button.component';
import { AddEditAssignBoxComponent } from './gamification/command-center/components/games/games-add-edit-components/add-edit-assign-box/add-edit-assign-box.component';
import { AssignBoxPipe } from './gamification/command-center/components/games/games-add-edit-components/add-edit-assign-box/assign-box.pipe';
import { Connect3MetricPopupComponent } from './gamification/command-center/components/games/games-add-edit-components/connect3-metric-popup/connect3-metric-popup.component';
import { ConfigureBoardConnect3Component } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-board-connect3/configure-board-connect3.component';
import { ConfigureBoardMilestoneComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-board-milestone/configure-board-milestone.component';
import { ConfigureEligibilityBracketsComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility-brackets/configure-eligibility-brackets.component';
import { ConfigureEligibilityComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility/configure-eligibility.component';
import { ConfigureEstimatorPopupComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-estimator-popup/configure-estimator-popup.component';
import { ConfigureEstimatorComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-estimator/configure-estimator.component';
import { ConfigureFoldersComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-folders/configure-folders.component';
import { ConfigureMetricComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-metric/configure-metric.component';
import { ConfigureNameComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-name/configure-name.component';
import { ConfigureQualifierComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-qualifier/configure-qualifier.component';
import { ConfigureRewardsBracketsComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-brackets/configure-rewards-brackets.component';
import { ConfigureRewardsBullseyeComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-bullseye/configure-rewards-bullseye.component';
import { ConfigureRewardsConnect3Component } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-connect3/configure-rewards-connect3.component';
import { ConfigureRewardsMilestoneComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-milestone/configure-rewards-milestone.component';
import { ConfigureRewardsMultiplierComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-multiplier/configure-rewards-multiplier.component';
import { ConfigureRewardsRaffleComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-raffle/configure-rewards-raffle.component';
import { ConfigureRewardsTopDogComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-top-dog/configure-rewards-top-dog.component';
import { ConfigureScheduleBracketsComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-schedule-brackets/configure-schedule-brackets.component';
import { ConfigureScheduleComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-schedule/configure-schedule.component';
import { GamesConfigureComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure/games-configure.component';
import { PickGameTypeComponent } from './gamification/command-center/components/games/games-add-edit-components/pick-game-type/pick-game-type.component';
import { GamesAddEditComponent } from './gamification/command-center/components/games/games-add-edit/games-add-edit.component';
import { GamesDetailsModalComponent } from './gamification/command-center/components/games/games-details-modal/games-details-modal.component';
import { GameHistoryBreakdownEffectivenessComponent } from './gamification/command-center/components/games/games-history-health-components/game-history-breakdown-effectiveness/game-history-breakdown-effectiveness.component';
import { GamesHistoryHealthReportComponent } from './gamification/command-center/components/games/games-history-health-report/games-history-health-report.component';
import { GamesHistoryComponent } from './gamification/command-center/components/games/games-history/games-history.component';
import { HealthReportExportButtonComponent } from './gamification/command-center/components/games/games-history-health-components/health-report-export-button/health-report-export-button.component';
import { HealthReportSpecificDetailsComponent } from './gamification/command-center/components/games/games-history-health-components/health-report-specific-details/health-report-specific-details.component';
import { HealthReportTopPerformersComponent } from './gamification/command-center/components/games/games-history-health-components/health-report-top-performers/health-report-top-performers.component';
import { GamesLandingComponent } from './gamification/command-center/components/games/games-landing/games-landing.component';
import { MilestoneBadgesRendererComponent } from './gamification/command-center/components/games/renderers/milestone-badges-renderer/milestone-badges-renderer.component';
import { MilestoneResultsRendererComponent } from './gamification/command-center/components/games/renderers/milestone-results-renderer/milestone-results-renderer.component';
import { RevertPayoutDetailsComponent } from './gamification/command-center/components/games/revert-payout-details/revert-payout-details.component';
import { GamificationExportComponent } from './gamification/gamification-export/gamification-export.component';
import { ObjectivesDetailsComponent } from './reusables/objectives-details/objectives-details.component';
// import { RewardDetailsComponent } from './gamification/command-center/components/games/reward-details/reward-details.component';
import { FloatingMenuModule as ButtonMenuSolModule } from '@niceltd/sol/floating-menu';
import { ProgressBarModule } from '@niceltd/sol/progress-bar';
import { QueryBuilderModule } from '@niceltd/sol/query-builder';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { SubscriptionManagementEditComponent } from 'src/app/admin/Subscription/subscription-management-edit/subscription-management-edit.component';
import { SubscriptionManagementComponent } from 'src/app/admin/Subscription/subscription-management/subscription-management.component';
import { CvPointStoreProductSettingCxoneComponent } from 'src/app/gamification/cv-marketplace-admin/components/cv-point-store-product-setting-cxone/cv-point-store-product-setting-cxone.component';
import { LaunchWallboardPreviewComponent } from './admin/launch-wallboard/launch-wallboard-preview/launch-wallboard-preview.component';
import { CXOneWallboardContextMenuCellRendererComponent } from './cxone/cxone-wallboards/context-menu-cell-renderer/context-menu-cell-renderer.component';
import { CxoneWallboardsComponent } from './cxone/cxone-wallboards/cxone-wallboards.component';
import { AgentStateSummarySettingsComponent } from './cxone/dashboard/module-settings/agent-state-summary-settings/agent-state-summary-settings.component';
import { CoachingStatusSettingsComponent } from './cxone/dashboard/module-settings/coaching-status-settings/coaching-status-settings.component';
import { ServiceLevelSettingsComponent } from './cxone/dashboard/module-settings/service-level-settings/service-level-settings.component';
import { AgentStateSummaryCellRendererComponent } from './cxone/dashboard/modules/agent-state-summary/agent-state-summary-cell-renderer/agent-state-summary-cell-renderer.component';
import { AgentStateSummaryDialerCellRendererComponent } from './cxone/dashboard/modules/agent-state-summary/agent-state-summary-dialer-cell-renderer/agent-state-summary-dialer-cell-renderer.component';
import { AgentStateSummaryComponent } from './cxone/dashboard/modules/agent-state-summary/agent-state-summary.component';
import { ContactStatesSkillCellRendererComponent } from './cxone/dashboard/modules/contact-states-skill/contact-states-skill-cell-renderer/contact-states-skill-cell-renderer.component';
import { ContactStatesSkillComponent } from './cxone/dashboard/modules/contact-states-skill/contact-states-skill.component';
import { BattleBoatChallengeComponent } from './dashboard/challenges/battleboat/battle-boat-challenge/battle-boat-challenge.component';
import { BattleBoatDetailsComponent } from './dashboard/challenges/battleboat/battle-boat-details/battle-boat-details.component';
import { BattleBoatShotComponent } from './dashboard/challenges/battleboat/battle-boat-shot/battle-boat-shot.component';
import { BoardShipsComponent } from './dashboard/challenges/battleboat/board-ships/board-ships.component';
import { BoardComponent } from './dashboard/challenges/battleboat/board/board.component';
import { ChallengeBattleBoatResultComponent } from './dashboard/challenges/battleboat/challenge-result/challenge-result.component';
import { ShadowBoxingResultComponent } from './dashboard/challenges/shadow-boxing-result/shadow-boxing-result.component';
import { ShadowBoxingPreviewComponent } from './dashboard/challenges/shadow-boxing/shadow-boxing-preview/shadow-boxing-preview.component';
import { ShadowBoxingProgressComponent } from './dashboard/challenges/shadow-boxing/shadow-boxing-progress/shadow-boxing-progress.component';
import { ChallengeCardViewComponent } from './dashboard/challenges/shared/challenge-card-view/challenge-card-view.component';
import { CreateReportSubscriptionComponent } from './dashboard/create-report-subscription/create-report-subscription.component';
import { AgentStateDetailCXOneComponent } from './dashboard/modals/agent-state-detail-cxone/agent-state-detail-cxone.component';
import { SuggestCoachingModalComponent } from './dashboard/modals/suggest-coaching-modal/suggest-coaching-modal.component';
import { ModuleLegacySettingsModalComponent } from './dashboard/module-legacy-settings-modal/module-legacy-settings-modal.component';
import { ScheduleAdherenceSettingsComponent } from './dashboard/module-settings/schedule-adherence-settings/schedule-adherence-settings.component';
import { ModuleSubscriptionSettingsContainerComponent } from './dashboard/module-subscription-settings-container/module-subscription-settings-container.component';
import { BANCOITAUComponent } from './dashboard/modules/banco-itau/banco-itau.component';
import { CoachingEffectivenessComponent } from './dashboard/modules/coaching-effectiveness/coaching-effectiveness.component';
import { AgentStateCellRendererComponent } from './dashboard/modules/current-agent-states/agent-state-cell-renderer/agent-state-cell-renderer.component';
import { CxoneChallengeCardComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-card/cxone-challenge-card.component';
import { CxoneChallengeCreateModalComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-create-modal/cxone-challenge-create-modal.component';
import { CxoneChallengeCreateComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-create/cxone-challenge-create.component';
import { CxoneChallengeHistoryModalComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-history-modal/cxone-challenge-history-modal.component';
import { CxoneChallengeLeaderboardModalComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-leaderboard-modal/cxone-challenge-leaderboard-modal/cxone-challenge-leaderboard-modal.component';
import { CxoneChallengeParticipantsModalComponent } from './dashboard/modules/cxone-challenge/cxone-challenge-participants-modal/cxone-challenge-participants-modal.component';
import { CxoneChallengesComponent } from './dashboard/modules/cxone-challenge/cxone-challenges.component';
import { CxoneGamesConnect3SlotComponent } from './dashboard/modules/cxone-games/cxone-games-connect-3/cxone-games-connect-3-slot/cxone-games-connect-3-slot.component';
import { CxoneGamesConnect3Component } from './dashboard/modules/cxone-games/cxone-games-connect-3/cxone-games-connect-3.component';
import { DispositionsComponent } from './dashboard/modules/dispositions/dispositions.component';
import { ScheduleAdherenceComponent } from './dashboard/modules/schedule-adherence/schedule-adherence.component';
import { PublishBarComponent } from './dashboard/publish-bar/publish-bar.component';
import { WorkspaceLandingComponent } from './dashboard/workspace/workspace-landing/workspace-landing.component';
import { CxoneChallengesLeadCellRendererComponent } from './gamification/command-center/components/challenges/challenges-list/cxone-challenges-lead-renderer/cxone-challenges-lead-renderer.component';
import { BracketViewComponent } from './gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility-brackets/bracket-view/bracket-view.component';
import { RaffleRewardsDetailsComponent } from './gamification/command-center/components/games/games-add-edit-components/raffle-rewards-details/raffle-rewards-details.component';
import { GamesHistoryExportButtonComponent } from './gamification/command-center/components/games/games-history-export-button/games-history-export-button.component';
import { GamesHistoryTableComponent } from './gamification/command-center/components/games/tables/games-history-table/games-history-table.component';
import { RewardEstimatorTableComponent } from './gamification/command-center/components/games/tables/reward-estimator-table/reward-estimator-table.component';
import { TeamsHistoryTableComponent } from './gamification/command-center/components/games/tables/teams-history-table/teams-history-table.component';
import { CommandCenterGroupSelectorComponent } from './gamification/command-center/components/overview/command-center-group-selector/command-center-group-selector.component';
import { CommandCenterComponent } from './gamification/command-center/components/overview/command-center/command-center.component';
import { CommandCenterOnboardingComponent } from './gamification/command-center/components/overview/modals/command-center-onboarding/command-center-onboarding.component';
import { GamesRunningModalComponent } from './gamification/command-center/components/overview/modals/games-running-modal/games-running-modal.component';
import { MarketplaceOrdersModalComponent } from './gamification/command-center/components/overview/modals/marketplace-orders-modal/marketplace-orders-modal.component';
import { MarketplaceOrdersTableComponent } from './gamification/command-center/components/overview/modals/marketplace-orders-table/marketplace-orders-table.component';
import { MarketplaceProductsModalComponent } from './gamification/command-center/components/overview/modals/marketplace-products-modal/marketplace-products-modal.component';
import { BadgesEarnedComponent } from './gamification/command-center/components/overview/modules/badges-earned/badges-earned.component';
import { CoinHistoryComponent } from './gamification/command-center/components/overview/modules/coin-history/coin-history.component';
import { CoinsEarnedComponent } from './gamification/command-center/components/overview/modules/coins-earned/coins-earned.component';
import { GamesRunningByTypeComponent } from './gamification/command-center/components/overview/modules/games-running-by-type/games-running-by-type.component';
import { MarketplaceOverviewComponent } from './gamification/command-center/components/overview/modules/marketplace-overview/marketplace-overview.component';
import { CustomMetricFormatterPipe } from './gamification/command-center/custom-pipes/custom-metric-formatter.pipe';
import { GamesFilterPipe } from './gamification/command-center/custom-pipes/games-filter.pipe';
import { CvAdminAwardsComponent } from './gamification/cv-admin/components/cv-admin-awards/cv-admin-awards.component';
import { CvAdminBudgetHistoryComponent } from './gamification/cv-admin/components/cv-admin-budget-history/cv-admin-budget-history.component';
import { CvAdminBudgetMeterComponent } from './gamification/cv-admin/components/cv-admin-budget-meter/cv-admin-budget-meter.component';
import { CvAdminBudgetNotificationsComponent } from './gamification/cv-admin/components/cv-admin-budget-notifications/cv-admin-budget-notifications.component';
import { CvAdminBudgetSetupComponent } from './gamification/cv-admin/components/cv-admin-budget-setup/cv-admin-budget-setup.component';
import { CvAdminBudgetTitleHeaderComponent } from './gamification/cv-admin/components/cv-admin-budget-title-header/cv-admin-budget-title-header.component';
import { CvAdminBudgetComponent } from './gamification/cv-admin/components/cv-admin-budget/cv-admin-budget.component';
import { CvAdminChallengeComponent } from './gamification/cv-admin/components/cv-admin-challenge/cv-admin-challenge.component';
import { CvAdminGamesComponent } from './gamification/cv-admin/components/cv-admin-games/cv-admin-games.component';
import { CvAdminLandingComponent } from './gamification/cv-admin/components/cv-admin-landing/cv-admin-landing.component';
import { CvPointStoreNewEditProductComponent } from './gamification/cv-marketplace-admin/components/cv-point-store-new-edit-product/cv-point-store-new-edit-product.component';
import { CvPointStoreProductAssignmentCxoneComponent } from './gamification/cv-marketplace-admin/components/cv-point-store-product-assignment-cxone/cv-point-store-product-assignment-cxone.component';
import { CvPointStoreProductInformationCxoneComponent } from './gamification/cv-marketplace-admin/components/cv-point-store-product-information-cxone/cv-point-store-product-information-cxone.component';
import { CvPointStoreProductSummaryCxoneComponent } from './gamification/cv-marketplace-admin/components/cv-point-store-product-summary-cxone/cv-point-store-product-summary-cxone.component';
import { CvPointStoreProductUploadCxoneComponent } from './gamification/cv-marketplace-admin/components/cv-point-store-product-upload-cxone/cv-point-store-product-upload-cxone.component';
import { CxoneOrderManagementGridLoaderComponent } from './gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-loader/cxone-order-management-grid-loader.component';
import { CxoneOrderManagementGridProductComponent } from './gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-product/cxone-order-management-grid-product.component';
import { CxoneOrderManagementGridTextContainerComponent } from './gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-text-container/cxone-order-management-grid-text-container.component';
import { CxoneOrderManagementNotesModalComponent } from './gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-notes-modal/cxone-order-management-notes-modal.component';
import { CxoneOrderManagementNotesTooltipComponent } from './gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-notes-tooltip/cxone-order-management-notes-tooltip.component';
import { CxoneOrderManagementGridComponent } from './gamification/cv-marketplace-admin/components/cxone-order-management-grid/cxone-order-management-grid.component';
import { CxoneOrderManagementComponent } from './gamification/cv-marketplace-admin/components/cxone-order-management/cxone-order-management.component';
import { FilesizeformatPipe } from './gamification/cv-marketplace-admin/pipes/filesizeformat.pipe';
import { CvMarketplaceCartDrawerComponent } from './gamification/cv-marketplace/components/cv-marketplace-cart-drawer/cv-marketplace-cart-drawer.component';
import { CvMarketplaceFilterComponent } from './gamification/cv-marketplace/components/cv-marketplace-filter/cv-marketplace-filter.component';
import { CvMarketplaceShoppingCartCarouselComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-carousel/cv-marketplace-shopping-cart-carousel.component';
import { CvMarketplaceShoppingCartCategoriesLandingComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-categories-landing/cv-marketplace-shopping-cart-categories-landing.component';
import { CvMarketplaceShoppingCartFeaturedComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-featured/cv-marketplace-shopping-cart-featured.component';
import { CvMarketplaceShoppingCartHomeComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-home/cv-marketplace-shopping-cart-home.component';
import { CvMarketplaceShoppingCartOrdersComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-orders/cv-marketplace-shopping-cart-orders.component';
import { CvMarketplaceShoppingCartProductDetailsComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-product-details/cv-marketplace-shopping-cart-product-details.component';
import { CvMarketplaceShoppingCartWishlistComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart-wishlist/cv-marketplace-shopping-cart-wishlist.component';
import { CvMarketplaceShoppingCartComponent } from './gamification/cv-marketplace/components/cv-marketplace-shopping-cart/cv-marketplace-shopping-cart.component';
import { CxoneOrderPlacedComponent } from './gamification/cv-marketplace/cxone-components/cxone-order-placed/cxone-order-placed.component';
import { CvMarketplaceProductsFilterPipe } from './gamification/cv-marketplace/pipes/cv-marketplace-products-filter.pipe';
import { MarketplaceOrdersTableComponentComponent } from './gamification/marketplace/admin/components/marketplace-orders-table-component/marketplace-orders-table-component.component';
import { PointStoreAssignGroupAttrComponent } from './gamification/marketplace/admin/components/point-store-assign-group-attr/point-store-assign-group-attr.component';
import { PointStoreCxoneSidebarComponent } from './gamification/marketplace/admin/components/point-store-cxone-sidebar/point-store-cxone-sidebar.component';
import { PointStoreEditComponent } from './gamification/marketplace/admin/components/point-store-edit/point-store-edit.component';
import { PointStoreNavigationBarComponent } from './gamification/marketplace/admin/components/point-store-navigation-bar/point-store-navigation-bar.component';
import { PointStoreOrdersAdminComponent } from './gamification/marketplace/admin/components/point-store-orders-admin/point-store-orders-admin.component';
import { PointStoreProductAssignmentComponent } from './gamification/marketplace/admin/components/point-store-product-assignment/point-store-product-assignment.component';
import { PointStoreProductGroupSelectorComponent } from './gamification/marketplace/admin/components/point-store-product-group-selector/point-store-product-group-selector.component';
import { PointStoreProductInformationComponent } from './gamification/marketplace/admin/components/point-store-product-information/point-store-product-information.component';
import { PointStoreProductLandingCardCvComponent } from './gamification/marketplace/admin/components/point-store-product-landing-card-cv/point-store-product-landing-card-cv.component';
import { PointStoreProductLandingCardComponent } from './gamification/marketplace/admin/components/point-store-product-landing-card/point-store-product-landing-card.component';
import { PointStoreProductLandingListComponent } from './gamification/marketplace/admin/components/point-store-product-landing-list/point-store-product-landing-list.component';
import { PointStoreProductLandingPageComponent } from './gamification/marketplace/admin/components/point-store-product-landing-page/point-store-product-landing-page.component';
import { PointStoreProductLandingThumbnailComponent } from './gamification/marketplace/admin/components/point-store-product-landing-thumbnail/point-store-product-landing-thumbnail.component';
import { PointStoreProductSettingComponent } from './gamification/marketplace/admin/components/point-store-product-setting/point-store-product-setting.component';
import { PointStoreProductSummaryComponent } from './gamification/marketplace/admin/components/point-store-product-summary/point-store-product-summary.component';
import { PointStoreProductUploadComponent } from './gamification/marketplace/admin/components/point-store-product-upload/point-store-product-upload.component';
import { FilterPipe } from './gamification/marketplace/admin/custom-pipes/filter.pipe';
import { GroupByPipe } from './gamification/marketplace/admin/custom-pipes/group-by.pipe';
import { ProductsFilterPipe } from './gamification/marketplace/admin/custom-pipes/products-filter.pipe';
import { UniquePipe } from './gamification/marketplace/admin/custom-pipes/unique.pipe';
import { AgentOrderHistoryComponent } from './gamification/marketplace/agent-side/components/agent-order-history/agent-order-history.component';
import { ShoppingCartLandingComponent } from './gamification/marketplace/agent-side/components/shopping-cart-landing/shopping-cart-landing.component';
import { ShoppingCartListComponent } from './gamification/marketplace/agent-side/components/shopping-cart-list/shopping-cart-list.component';
import { ListFilterPipe } from './gamification/marketplace/agent-side/custom-pipes/list-filter.pipe';
import { DeleteBtnRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/delete-btn-rendered/delete-btn-rendered.component';
import { FooterButtonRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/footer-button-rendered/footer-button-rendered.component';
import { FooterEmptyRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/footer-empty-rendered/footer-empty-rendered.component';
import { FooterSubtotalRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/footer-subtotal-rendered/footer-subtotal-rendered.component';
import { QtyInputRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/qty-input-rendered/qty-input-rendered.component';
import { ReorderBtnRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/reorder-btn-rendered/reorder-btn-rendered.component';
import { SubtotalRenderedComponent } from './gamification/marketplace/agent-side/custom-renders/subtotal-rendered/subtotal-rendered.component';
import { WINDOW_INJECTION_TOKEN } from './injection-tokens';
import { NavigationHeaderMenuComponent } from './navigation/navigation-header/navigation-header-menu/navigation-header-menu.component';
import { SubmitFeedbackComponent } from './navigation/navigation-header/submit-feedback/submit-feedback.component';
import { NgxCleaveDirective } from './ngx-cleave-directive-cv-custom/ngx-cleave-directive-cv-custom.component';
import { ReleaseModalComponent } from './notifications/release-modal/release-modal.component';
import { CategorizeMetricDefinitions } from './pipeline-config/categorize-metric-definitions.pipe';
import { EditMetricComponent } from './pipeline-config/edit-metric/edit-metric.component';
import { IntegrationMongoLogsCellRendererComponent } from './pipeline-config/integration-mongo-logs/integration-mongo-logs-cell-renderer/integration-mongo-logs-cell-renderer.component';
import { IntegrationMongoLogsComponent } from './pipeline-config/integration-mongo-logs/integration-mongo-logs.component';
import { MetricComponentModalComponent } from './pipeline-config/metric-component-modal/metric-component-modal.component';
import { MetricComponentPreviewComponent } from './pipeline-config/metric-component-preview/metric-component-preview.component';
import { MetricDefinitionsLandingComponent } from './pipeline-config/metric-definitions-landing/metric-definitions-landing.component';
import { MetricFormulaComponent } from './pipeline-config/metric-formula/metric-formula.component';
import { MetricSummaryComponent } from './pipeline-config/metric-summary/metric-summary.component';
import { AddCustomHierarchyComponent } from './pipeline/hierarchy/add-custom-hierarchy/add-custom-hierarchy.component';
import { RecordingsDetailsComponent } from './recordings/recordings-details/recordings-details.component';
import { RecordingsLandingComponent } from './recordings/recordings-landing/recordings-landing.component';
import { ManageReportsComponent } from './reports/manage-reports/manage-reports.component';
import { SysTemplateActionCellRendererComponent } from './reports/manage-reports/systemplate-action-cell-renderer/systemplate-action-cell-renderer.component';
import { SystemplateCellRendererComponent } from './reports/manage-reports/systemplate-cell-renderer/systemplate-cell-renderer.component';
import { SystemplateStatusCellRendererComponent } from './reports/manage-reports/systemplate-status-cell-renderer/systemplate-status-cell-renderer/systemplate-status-cell-renderer.component';
import { CvAngularLoadingOverlayComponent } from './reusables/ag-grid-components/cv-angular-loading-overlay/cv-angular-loading-overlay.component';
import { CxoneCheckboxCellComponent } from './reusables/ag-grid-components/cxone-checkbox-cell/cxone-checkbox-cell.component';
import { CxoneCheckboxHeaderComponent } from './reusables/ag-grid-components/cxone-checkbox-header/cxone-checkbox-header.component';
import { CxoneHighlightSearchCellRendererComponent } from './reusables/ag-grid-components/cxone-highlight-search-cell-renderer/cxone-highlight-search-cell-renderer.component';
import { CxoneTruncateTextCellRendererComponent } from './reusables/ag-grid-components/cxone-truncate-text-cell-renderer/cxone-truncate-text-cell-renderer.component';
import { AngularAssignToolComponent } from './reusables/assign-tool/angular-assign-tool/angular-assign-tool.component';
import { CvCxoneAssignToolComponent } from './reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.component';
import { CxoneLoginsAssignToolComponent } from './reusables/assign-tool/cxone-logins-assign-tool/cxone-logins-assign-tool.component';
import { DashboardAssignmentPermissionsRendererComponent } from './reusables/assign-tool/dashboard-assignment/dashboard-assignment-permissions-renderer/dashboard-assignment-permissions-renderer.component';
import { DashboardAssignmentComponent } from './reusables/assign-tool/dashboard-assignment/dashboard-assignment.component';
import { MetricDefinitionAssignmentComponent } from './reusables/assign-tool/metric-definition-assignment/metric-definition-assignment.component';
import { AttributeSelectorComponent } from './reusables/attribute-selector/attribute-selector.component';
import { BadgeSelectorComponent } from './reusables/badge-selector/badge-selector.component';
import { BaremetricsCalendarComponent } from './reusables/baremetrics-calendar/baremetrics-calendar.component';
import { BroadcastAssignComponent } from './reusables/broadcasts/broadcast-assign/broadcast-assign.component';
import { BroadcastDetailsComponent } from './reusables/broadcasts/broadcast-details/broadcast-details.component';
import { ConfirmDialogComponent } from './reusables/confirm-dialog/confirm-dialog.component';
import { CustomBadgeCreatorComponent } from './reusables/custom-badge-creator/custom-badge-creator.component';
import { CustomDialogComponent } from './reusables/custom-dialog/custom-dialog.component';
import { CvLoaderComponent } from './reusables/cv-loader/cv-loader.component';
import { CvLocalizedAttrsDirective } from './reusables/cv-localized-attrs.directive';
import { DateParadigmFilterComponent } from './reusables/date-paradigm-filter/date-paradigm-filter.component';
import { DateRangeSelectorComponent } from './reusables/date-range-selector/date-range-selector.component';
import { DowSelectorComponent } from './reusables/dow-selector/dow-selector.component';
import { FormDisplayComponent } from './reusables/form-display/form-display.component';
import { GeneralWallboardSettingsSelectorComponent } from './reusables/general-wallboard-settings-selector/general-wallboard-settings-selector.component';
import { GridTemplateComponent } from './reusables/grid-template/grid-template.component';
import { GroupSelectorComponent } from './reusables/group-selector/group-selector.component';
import { GroupViewBySelectorComponent } from './reusables/group-view-by-selector/group-view-by-selector.component';
import { ImageFallbackDirective } from './reusables/image-fallback/image-fallback.directive';
import { ImgCropComponent } from './reusables/img-crop/img-crop.component';
import { AutoFocusDirective } from "./reusables/input-auto-focus/input-auto-focus.directive";
import { InputNumericFormatDirective } from './reusables/input-numeric-format/input-numeric-format.directive';
import { InteractiveBarComponent } from './reusables/interactive-bar/interactive-bar.component';
import { IntervalSelectorComponent } from './reusables/interval-selector/interval-selector.component';
import { CvLocalizedPlaceholderDirective } from './reusables/localization/cv-localized-placeholder.directive';
import { MetricDynamicFiltersComponent } from './reusables/metric-dynamic-filters/metric-dynamic-filters.component';
import { MetricSelectorComponent } from './reusables/metric-selector/metric-selector.component';
import { MultiSelectComponent } from './reusables/multi-select/multi-select.component';
import { NavigationSidebarClassDirective } from './reusables/navigation-sidebar-class/navigation-sidebar-class.directive';
import { NgModelChangeDebouncedDirective } from './reusables/ng-model-change-debounced/ng-model-change-debounced.directive';
import { ArraySortPipe } from './reusables/pipes/array-sort.pipe';
import { BoldTextPipe } from './reusables/pipes/bold-text.pipe';
import { CleanIdPipe } from './reusables/pipes/clean-id.pipe';
import { CvNumberLocalizePipe } from './reusables/pipes/cv-number-localize.pipe';
import { CvOrdinalLocalizePipe } from './reusables/pipes/cv-ordinal-localize.pipe';
import { EncodeColorPipe } from './reusables/pipes/encode-color.pipe';
import { FilterTextPipe } from './reusables/pipes/filter-text.pipe';
import { FormatNumericTypePipe } from './reusables/pipes/format-numeric-type.pipe';
import { GenericMetricFormatterPipe } from './reusables/pipes/generic-metric-formatter.pipe';
import { LimitToPipe } from './reusables/pipes/limit-to.pipe';
import { NumberLocalizePipe } from './reusables/pipes/number-localize.pipe';
import { OrderByPipe } from './reusables/pipes/order-by.pipe';
import { SafeUrlPipe } from './reusables/pipes/safe-url.pipe';
import { StartOnPipe } from './reusables/pipes/start-on.pipe';
import { PreventMenuCloseDirective } from './reusables/prevent-menu-close/prevent-menu-close.directive';
import { ProfilePictureApprovalComponent } from './reusables/profile-picture-approval/profile-picture-approval.component';
import { QuickDateRangeSelectorComponent } from './reusables/quick-date-range-selector/quick-date-range-selector.component';
import { ReportingsetDynamicFiltersWrapperComponent } from './reusables/reportingset-dynamic-filters-wrapper/reportingset-dynamic-filters-wrapper.component';
import { ReportingSetDynamicFiltersComponent } from "./reusables/reportingset-dynamic-filters/reportingset-dynamic-filters.component";
import { CVApiService } from './reusables/services/cv-api.service';
import { SettingsSlideoutComponent } from './reusables/settings-slideout/settings-slideout.component';
import { SingleAttributeSelectorComponent } from './reusables/single-attribute-selector/single-attribute-selector.component';
import { SingleSelectComponent } from './reusables/single-select/single-select.component';
import { SubscriptionSchedulerComponent } from './reusables/subscription-scheduler/subscription-scheduler.component';
import { TimeEntryDirective } from './reusables/time-entry/time-entry.directive';
import { TimePickerComponent } from './reusables/time-picker/time-picker.component';
import { TimeRangeSelectorComponent } from './reusables/time-range-selector/time-range-selector.component';
import { TimeSliderComponent } from './reusables/time-slider/time-slider.component';
import { WallboardColumnSortSelectorComponent } from './reusables/wallboard-column-sort-selector/wallboard-column-sort-selector.component';
import { WarningDialogComponent } from './reusables/warning-dialog/warning-dialog.component';
import { WallboardViewChallengesComponent } from './wallboards/wallboardView/wallboard-view-challenges/wallboard-view-challenges.component';
import { WallboardViewCurrentAgentStatesResponsiveComponent } from './wallboards/wallboardView/wallboard-view-current-agent-states-responsive/wallboard-view-current-agent-states-responsive.component';
import { WallboardViewCurrentAgentStatesComponent } from './wallboards/wallboardView/wallboard-view-current-agent-states/wallboard-view-current-agent-states.component';
import { WallboardViewCustomAchievementComponent } from './wallboards/wallboardView/wallboard-view-custom-achievement/wallboard-view-custom-achievement.component';
import { WallboardViewCustomAgentCounterComponent } from './wallboards/wallboardView/wallboard-view-custom-agent-counter/wallboard-view-custom-agent-counter.component';
import { WallboardViewCustomGaugeComponent } from './wallboards/wallboardView/wallboard-view-custom-gauge/wallboard-view-custom-gauge.component';
import { WallboardViewCustomImageComponent } from './wallboards/wallboardView/wallboard-view-custom-image/wallboard-view-custom-image.component';
import { WallboardViewCustomKpiComponent } from './wallboards/wallboardView/wallboard-view-custom-kpi/wallboard-view-custom-kpi.component';
import { WallboardViewCustomSummaryComponent } from './wallboards/wallboardView/wallboard-view-custom-summary/wallboard-view-custom-summary.component';
import { WallboardViewCustomTextComponent } from './wallboards/wallboardView/wallboard-view-custom-text/wallboard-view-custom-text.component';
import { WallboardViewCustomThermometerComponent } from './wallboards/wallboardView/wallboard-view-custom-thermometer/wallboard-view-custom-thermometer.component';
import { WallboardViewCustomTopComponent } from './wallboards/wallboardView/wallboard-view-custom-top/wallboard-view-custom-top.component';
import { WallboardViewCustomComponent } from './wallboards/wallboardView/wallboard-view-custom/wallboard-view-custom.component';
import { WallboardViewGamesComponent } from './wallboards/wallboardView/wallboard-view-games/wallboard-view-games.component';
import { WallboardViewImageComponent } from './wallboards/wallboardView/wallboard-view-image/wallboard-view-image.component';
import { WallboardViewLeaderboardComponent } from './wallboards/wallboardView/wallboard-view-leaderboard/wallboard-view-leaderboard.component';
import { WallboardViewMainComponent } from './wallboards/wallboardView/wallboard-view-main/wallboard-view-main.component';
import { WallboardViewMarketplaceComponent } from './wallboards/wallboardView/wallboard-view-marketplace/wallboard-view-marketplace.component';
import { WallboardViewRacingComponent } from './wallboards/wallboardView/wallboard-view-racing/wallboard-view-racing.component';
import { WallboardViewScorecardComponent } from './wallboards/wallboardView/wallboard-view-scorecard/wallboard-view-scorecard.component';
import { WallboardViewSpotlightComponent } from './wallboards/wallboardView/wallboard-view-spotlight/wallboard-view-spotlight.component';
import { WallboardViewSummaryComponent } from './wallboards/wallboardView/wallboard-view-summary/wallboard-view-summary.component';
import { WallboardViewVideoComponent } from './wallboards/wallboardView/wallboard-view-video/wallboard-view-video.component';
import { WallboardsAssignComponent } from './wallboards/wallboards-assign.component';
import { WallboardsComponent } from './wallboards/wallboards.component';
import { WorkAidsNewComponent } from './work-aids/work-aids-new/work-aids-new.component';
import { WorkAidsComponent } from './work-aids/work-aids.component';


import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeNl from '@angular/common/locales/nl';
import localePt from '@angular/common/locales/pt';
import localeSv from '@angular/common/locales/sv';
import localeZh from '@angular/common/locales/zh';

export const AppInitializerFactory = (
    i18next: ITranslationService,
    locationInitializer: LocalizationInitializer,
    config: ConfigurationCoreService,
    cvApiService: CVApiService
) => (async () => {

    // If there is a token URL to pull from
    if (window['navigationData']?.CXOneTokenUrls != null) {
        const cxoneTokenUrls = window['navigationData'].CXOneTokenUrls;
        config.setConfigurationData({
            languageMetaDataPath: `${cxoneTokenUrls.niceBaseUrl}/apps`,
            apiServerBaseUrl: cxoneTokenUrls.niceBaseUrl
        });
        await locationInitializer.load();
    }
    else {
        const englishDefault = await cvApiService.get('/dist/angular/assets/strings/components/cxone-core-components/strings_en_US.json');
        const domainEnglishDefault = await cvApiService.get(
            '/dist/angular/assets/strings/components/cxone-domain-components/strings_en_US.json');

        const languageDetector: LanguageDetectorModule = {
            type: 'languageDetector',
            detect: () => "en-US",
            init: (_ => { }),
            cacheUserLanguage: (_ => { }),
        };

        const initOptions: InitOptions = {
            fallbackLng: 'en',
            defaultNS: 'ns',
            ns: ['ns'],
            resources: {
                en: {
                    ns: { ...englishDefault, ...domainEnglishDefault }
                },
            },
        };

        await i18next.use(languageDetector).init(initOptions);
    }

    // Add languages that are supported from the browser for Angular to map to.
    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localeDe, 'de');
    registerLocaleData(localeEs, 'es');
    registerLocaleData(localePt, 'pt');
    registerLocaleData(localeJa, 'ja');
    registerLocaleData(localeKo, 'ko');
    registerLocaleData(localeNl, 'nl');
    registerLocaleData(localeZh, 'zh');
    registerLocaleData(localeSv, 'sv');
});

@NgModule({
    declarations: [
        AboutComponent,
        AccessUseradminComponent,
        AcdCallbackComponent,
        ActionRendererComponent,
        ActionsCellRendererComponent,
        ActiveRendererComponent,
        AddCustomHierarchyComponent,
        AddEditAssignBoxComponent,
        AddSimpleFeedModalComponent,
        AddUserComponent,
        AgentCounterComponent,
        AgentCounterSettingsComponent,
        AgentOrderHistoryComponent,
        AgentStateDetailComponent,
        AgentStateDetailCXOneComponent,
        AgentStatesColorModalComponent,
        AgentStateSummaryCellRendererComponent,
        AgentStateCellRendererComponent,
        AgentStateSummaryComponent,
        AgentStateSummaryDialerCellRendererComponent,
        AgentStateSummarySettingsComponent,
        AgGridGroupHeaderTooltipComponent,
        AgGridIChartTemplateComponent,
        AngularAssignToolComponent,
        AnnouncementsComponent,
        AnnouncementsNewComponent,
        ArraySortPipe,
        AssignBoxPipe,
        AssociatedMetricsComponent,
        AttributeSelectorComponent,
        AttributesUseradminComponent,
        AutoFocusDirective,
        AwardsExportButtonComponent,
        AwardsHistoryListComponent,
        AwardCardComponent,
        AwardsCardMenuComponent,
        AwardsLandingComponent,
        AwardsAddEditComponent,
        AwardedPopupComponent,
        AwardsFilterPipe,
        BadgesEarnedComponent,
        BadgeSelectorComponent,
        BANCOITAUComponent,
        BaremetricsCalendarComponent,
        BattleBoatChallengeComponent,
        BoardComponent,
        BattleBoatDetailsComponent,
        BattleBoatShotComponent,
        BoardShipsComponent,
        BoldTextPipe,
        BracketViewComponent,
        BroadcastDetailsComponent,
        BroadcastAssignComponent,
        BudgetExportButtonComponent,
        CalculatorComponent,
        CalculatedMetricBreakdownComponent,
        CalculatedMetricBreakdownFormulaComponent,
        CalculatedMetricBreakdownSettingsComponent,
        CallArrivalComponent,
        CallArrivalSettingsComponent,
        CategorizeMetricDefinitions,
        CategoryOverTimeComponent,
        CategoryOverTimeSettingsComponent,
        CategorySelectionModalComponent,
        ChallengeBattleBoatResultComponent,
        ChallengeCardViewComponent,
        ChallengedUsersModalComponent,
        ChallengesHistoryComponent,
        ChallengesListComponent,
        ChallengesSettingsComponent,
        ChannelTypeCellRendererComponent,
        CleanIdPipe,
        CoachingEffectivenessComponent,
        CoachingStatusComponent,
        CoachingStatusSettingsComponent,
        CoachingTypeFilterComponent,
        CoinHistoryComponent,
        CoinsEarnedComponent,
        CommandCenterComponent,
        CommandCenterGroupSelectorComponent,
        CommandCenterOnboardingComponent,
        CompanyEditSsoComponent,
        CompanySettingsComponent,
        ComparisonFieldComponent,
        ContextMenuAwardsDialogComponent,
        ConfigureBoardConnect3Component,
        ConfigureBoardMilestoneComponent,
        ConfigureEligibilityBracketsComponent,
        ConfigureEligibilityComponent,
        ConfigureEstimatorComponent,
        ConfigureEstimatorPopupComponent,
        ConfigureFoldersComponent,
        ConfigureMetricComponent,
        ConfigureNameComponent,
        ConfigureQualifierComponent,
        ConfigureRewardsBracketsComponent,
        ConfigureRewardsBullseyeComponent,
        ConfigureRewardsConnect3Component,
        ConfigureRewardsMilestoneComponent,
        ConfigureRewardsMultiplierComponent,
        ConfigureRewardsRaffleComponent,
        ConfigureRewardsTopDogComponent,
        ConfigureScheduleComponent,
        ConfigureScheduleBracketsComponent,
        ConfirmDialogComponent,
        Connect3MetricPopupComponent,
        ContactGroupComponent,
        ContactListComponent,
        ContactListDetailsComponent,
        ContactListSettingsComponent,
        ContactListImageCellRendererComponent,
        ContactStateCellRendererComponent,
        ContactStatesSkillCellRendererComponent,
        ContactStatesSkillComponent,
        ContactStatesSkillSettingsComponent,
        ContextMenuCellRendererComponent,
        CreateEditEtlDataFeedComponent,
        CreateNewDashboardComponent,
        CreateNewReportModalComponent,
        CreateReportSubscriptionComponent,
        CSMInnerRenderer,
        CurrencyPendingExportButtonComponent,
        CurrentAgentStatesComponent,
        CurrentAgentStatesPmComponent,
        CurrentAgentStatesCxoneComponent,
        CurrentAgentStatesPmGraphComponent,
        CurrentAgentStatesCxoneGraphComponent,
        CurrentAgentStatesPmTableComponent,
        CurrentAgentStatesCxoneTableComponent,
        CurrentAgentStatesSettingsComponent,
        CustomBadgeCreatorComponent,
        CustomDialogComponent,
        CustomMetricFormatterPipe,
        CustomNoRowsOverlayComponent,
        CustomTooltipCellRendererComponent,
        CvAdminAwardsComponent,
        CvAdminBudgetComponent,
        CvAdminBudgetHistoryComponent,
        CvAdminBudgetMeterComponent,
        CvAdminBudgetNotificationsComponent,
        CvAdminBudgetSetupComponent,
        CvAdminBudgetTitleHeaderComponent,
        CvAdminChallengeComponent,
        CvAdminGamesComponent,
        CvAdminLandingComponent,
        CvAngularLoadingOverlayComponent,
        CvCxoneAssignToolComponent,
        CxoneLoginsAssignToolComponent,
        CVGaugeComponent,
        CvLoaderComponent,
        CvLocalizedAttrsDirective,
        CvLocalizedPlaceholderDirective,
        CVLocalizedTextDirective,
        CvMarketplaceCartDrawerComponent,
        CvMarketplaceFilterComponent,
        CvMarketplaceProductsFilterPipe,
        CvMarketplaceShoppingCartCarouselComponent,
        CvMarketplaceShoppingCartCategoriesLandingComponent,
        CvMarketplaceShoppingCartComponent,
        CvMarketplaceShoppingCartFeaturedComponent,
        CvMarketplaceShoppingCartHomeComponent,
        CvMarketplaceShoppingCartOrdersComponent,
        CvMarketplaceShoppingCartProductDetailsComponent,
        CvMarketplaceShoppingCartWishlistComponent,
        CvNumberLocalizePipe,
        CvOrdinalLocalizePipe,
        CvPointStoreNewEditProductComponent,
        CvPointStoreProductAssignmentCxoneComponent,
        CvPointStoreProductInformationCxoneComponent,
        CvPointStoreProductSettingCxoneComponent,
        CvPointStoreProductSummaryCxoneComponent,
        CvPointStoreProductUploadCxoneComponent,
        CXOneAddWidgetComponent,
        CxoneAgentCardComponent,
        CxoneAttributeSelectorComponent,
        CxoneAwardModalComponent,
        CXOneCallArrivalComponent,
        CxoneCallArrivalSettingsComponent,
        CxoneColumnHeaderRendererComponent,
        CxoneChallengesComponent,
        CxoneChallengeCardComponent,
        CxoneChallengeParticipantsModalComponent,
        CxoneChallengeLeaderboardModalComponent,
        CxoneChallengeHistoryModalComponent,
        CxoneChallengeCreateModalComponent,
        CxoneChallengeCreateComponent,
        CxoneChallengesLeadCellRendererComponent,
        CxoneCheckboxCellComponent,
        CxoneCheckboxHeaderComponent,
        CxoneContactStateDescriptionsSelectorComponent,
        CxoneContextMenuCellRendererComponent,
        CxoneCustomDataImportComponent,
        CxoneCustomDataImportDialogComponent,
        CxoneCustomDataImportViewComponent,
        CxoneDashboardContentComponent,
        CxoneDashboardFilterComponent,
        CXOneDashboardHeaderComponent,
        CxoneDashboardNameCellRendererComponent,
        CxoneDateRangeSelectorComponent,
        CxoneDispositionsComponent,
        CxoneEmptyWorkspaceComponent,
        CxoneEtlDataFeedComponent,
        CxoneEtlDataFeedDependenciesComponent,
        CxoneEtlDataFeedViewComponent,
        CxoneEtlDataRecalculationComponent,
        CxoneEtlLoadFromFileComponent,
        CxoneEtlRecalculationModalComponent,
        CxoneEtlReportingSetComponent,
        CxoneEtlReportingSetDependenciesComponent,
        CxoneEtlReportingSetJoinedFeedComponent,
        CxoneEvaluationCoachingTrendComponent,
        CXoneEvaluationCoachingTrendSettingsComponent,
        CXOneFirstPhaseIntegrationComponent,
        CxoneGameCardComponent,
        CxoneBullseyeGameComponent,
        CxoneGameMultiplierMadnessComponent,
        CxoneGameQualifierComponent,
        CxoneGamesMilestoneComponent,
        CxoneGamesComponent,
        CxoneGamesConnect3Component,
        CxoneGamesConnect3SlotComponent,
        CxoneGamesTrackerComponent,
        CxoneGameTopTeamComponent,
        CXoneGaugeComponent,
        CxoneHighlightSearchCellRendererComponent,
        CxoneIntervalSelectorComponent,
        CxoneKpiTrendComponent,
        CxoneManageMetricsComponent,
        CxoneMetricNameCellRendererComponent,
        CxoneModuleSettingsModalComponent,
        CxoneMyRankingComponent,
        CxoneNewCategoryWindowComponent,
        CxoneObjectivesComponent,
        CxoneOrderPlacedComponent,
        CxonePlayIconCellComponent,
        CxonePopoutComponent,
        CxoneRecalculationMetricViewComponent,
        CxoneRecalculationReportingSetViewComponent,
        CxoneReportingSetCoalesceFieldComponent,
        CxoneReportingSetComplexDateFieldComponent,
        CxoneReportingSetComplexNumericFieldComponent,
        CxoneReportingSetComplexStringFieldComponent,
        CxoneReportingSetConditionalFieldComponent,
        CxoneReportingSetCreateEditComponent,
        CxoneReportingSetDataFieldComponent,
        CxoneReportingSetFlowBuilderComponent,
        CxoneReportingSetRegexFieldComponent,
        CxoneReportingSetSimpleFieldComponent,
        CxoneReportingSetSubstringFieldComponent,
        CxoneSeeMoreComponent,
        CxoneSelectAwardCardComponent,
        CxoneTeamsComponent,
        CxoneTruncateTextCellRendererComponent,
        CxoneWallboardsComponent,
        CXOneWallboardContextMenuCellRendererComponent,
        DashboardAccessComponent,
        DashboardAssignmentComponent,
        DashboardAssignmentPermissionsRendererComponent,
        DashboardFilterSlideoutComponent,
        DashboardNameRendererComponent,
        DashboardProjectionContentComponent,
        DashboardsUseradminComponent,
        DashboardWindowComponent,
        DataFeedActionsCellRendererComponent,
        DataTypeRendererComponent,
        DateParadigmFilterComponent,
        DateRangeSelectorComponent,
        DeleteBtnRenderedComponent,
        DeleteRowRenderer,
        DeleteSubscriptionComponent,
        DescriptionCellRendererComponent,
        DetailsUseradminComponent,
        DispositionsComponent,
        DowSelectorComponent,
        DrawLinesComponent,
        EditMetricComponent,
        EmbeddedMessagesComponent,
        EmployeeGroupComponent,
        EmptyObjectivesTabComponent,
        EncodeColorPipe,
        EtlCustomCellValueRendererComponent,
        EvaluatorCalibrationComponent,
        EvaluatorCalibrationSettingsComponent,
        ExpandedSummaryComponent,
        ExpandedSummarySettingsComponent,
        ExtendedKpiComponent,
        ExtendedKpiItemComponent,
        FailedImportReportComponent,
        FavoriteButtonRendererComponent,
        FieldNameRendererComponent,
        FilesizeformatPipe,
        FilterFieldsEditComponent,
        FilterPipe,
        FilterTextPipe,
        FilesizeformatPipe,
        FooterButtonRenderedComponent,
        FooterEmptyRenderedComponent,
        FooterSubtotalRenderedComponent,
        FormatNumericTypePipe,
        FormsAssignComponent,
        FormsCalibrationComponent,
        FormsCalibrationSettingsComponent,
        FormsComponent,
        FrustrationModeSelectorComponent,
        FunctionOperatorFieldComponent,
        GainsightInjectorComponent,
        GamesAddEditComponent,
        GamesConfigureComponent,
        GamesDetailsModalComponent,
        GamesFilterPipe,
        GamesHistoryComponent,
        GameHistoryBreakdownEffectivenessComponent,
        GamesHistoryExportButtonComponent,
        GamesHistoryHealthReportComponent,
        GamesHistoryTableComponent,
        GamesLandingComponent,
        GamesRunningByTypeComponent,
        GamesRunningModalComponent,
        GamificationDetailPageComponent,
        GamificationExportComponent,
        GamificationPageComponent,
        GeneralWallboardSettingsSelectorComponent,
        GenericExportComponent,
        GenericMetricFormatterPipe,
        GiveAwardPopupComponent,
        GridTemplateComponent,
        GroupByPipe,
        GroupSelectorComponent,
        GroupViewBySelectorComponent,
        HealthReportExportButtonComponent,
        HealthReportSpecificDetailsComponent,
        HealthReportTopPerformersComponent,
        HeatmapComponent,
        IaFrustrationComponent,
        IaFrustrationSettingsComponent,
        ImageFallbackDirective,
        ImageUploadComponent,
        ImgCropComponent,
        ImportActionCellComponent,
        InputNumericFormatDirective,
        IntegrationMongoLogsCellRendererComponent,
        IntegrationMongoLogsComponent,
        InteractiveBarComponent,
        IntervalComboComponent,
        IntervalComboSettingsComponent,
        IntervalSelectorComponent,
        KpiComponent,
        KpiTrendCoachingEventsComponent,
        KpiTrendCoachingHeaderComponent,
        LaunchCXOneDashAdminComponent,
        LaunchWallboardComponent,
        LaunchWallboardPreviewComponent,
        LeaderboardComponent,
        LeaderboardMyMetricComponent,
        LeaderboardRankCellRendererComponent,
        LineAnchorDirective,
        LinkedContactsComponent,
        LinkedContactsDetailsComponent,
        ListFilterPipe,
        LoadFromFileTreeComponent,
        LockIconCellRendererComponent,
        LoginLogoutComponent,
        ManageAvailableDashboardsComponent,
        ManageMetricsRecalculationDetailsModalComponent,
        ManageMetricsRecalculationModalComponent,
        ManageReportsComponent,
        MarketplaceOrdersModalComponent,
        MarketplaceOrdersTableComponent,
        MarketplaceOrdersTableComponentComponent,
        MarketplaceOverviewComponent,
        MarketplaceProductsModalComponent,
        MetricComponentModalComponent,
        MetricComponentPreviewComponent,
        MetricDefinitionAssignmentComponent,
        MetricDefinitionsLandingComponent,
        MetricDetailedViewComponent,
        MetricDynamicFiltersComponent,
        MetricFormulaComponent,
        MetricReviewComponent,
        MetricsBreakDownComponent,
        MetricSelectorComponent,
        MetricSummaryComponent,
        MilestoneBadgesRendererComponent,
        MilestoneResultsRendererComponent,
        ModuleContainerComponent,
        ModuleCustomSettingSectionComponent,
        ModuleCxoneCustomSettingSectionDirective,
        ModuleErrorComponent,
        ModuleLegacyCustomSettingSectionDirective,
        ModuleLegacySettingsModalComponent,
        ModulePreviewComponent,
        ModuleSubscriptionSettingsContainerComponent,
        MultiSelectComponent,
        MyRankingComponent,
        MyRankingCardComponent,
        NavigationHeaderMenuComponent,
        NavigationSidebarClassDirective,
        NewSystemTemplateComponent,
        NgModelChangeDebouncedDirective,
        NgTemplateComponent,
        NgTemplateSettingsComponent,
        NgxCleaveDirective,
        NotepadComponent,
        NotificationEditCellRendererComponent,
        ObjectiveAddEditComponent,
        ObjectiveAssignComponent,
        ObjectivesDetailsComponent,
        ObjectiveGroupsAssignedComponent,
        ObjectiveGroupsCardViewComponent,
        ObjectiveLandingComponent,
        ObjectiveMetricsAssignedComponent,
        ObjectiveTimePipe,
        OpenExistingDashboardComponent,
        OpenExistingTemplateComponent,
        OwnerCellRendererComponent,
        PackagesUseradminComponent,
        PageAccessCellRenderer,
        PermissionAssignBoxComponent,
        PermissionCellRendererComponent,
        PermissionsUseradminComponent,
        PickGameTypeComponent,
        PlansStatusComponent,
        PlansStatusSettingsComponent,
        PointStoreAssignGroupAttrComponent,
        PointStoreCxoneSidebarComponent,
        PointStoreEditComponent,
        CxoneOrderManagementComponent,
        CxoneOrderManagementGridComponent,
        CxoneOrderManagementGridProductComponent,
        CxoneOrderManagementGridLoaderComponent,
        CxoneOrderManagementNotesTooltipComponent,
        CxoneOrderManagementNotesModalComponent,
        CxoneOrderManagementGridTextContainerComponent,
        PointStoreNavigationBarComponent,
        PointStoreOrdersAdminComponent,
        PointStoreProductAssignmentComponent,
        PointStoreProductGroupSelectorComponent,
        PointStoreProductInformationComponent,
        PointStoreProductLandingCardComponent,
        PointStoreProductLandingCardCvComponent,
        PointStoreProductLandingListComponent,
        PointStoreProductLandingPageComponent,
        PointStoreProductLandingThumbnailComponent,
        PointStoreProductSettingComponent,
        PointStoreProductSummaryComponent,
        PointStoreProductUploadComponent,
        PreventMenuCloseDirective,
        PrimaryKeyHeaderComponent,
        PrimaryKeyRendererComponent,
        ProductsFilterPipe,
        ProfilePictureApprovalComponent,
        PublishBarComponent,
        QmEvaluationsCoachingComponent,
        QmEvaluationsCoachingSettingsComponent,
        QmEvaluatorPerformanceComponent,
        QmEvaluatorPerformanceComparisonComponent,
        QmEvaluatorPerformanceTrendComponent,
        QmEvaluatorPerformanceSettingsComponent,
        QtyInputRenderedComponent,
        QualityScoreComponent,
        QualityScoreGridCustomHeaderComponent,
        QualityScoreMetricCellRendererComponent,
        QualityScoreSettingsComponent,
        QualityScoreUserCellRendererComponent,
        QueueCounterComponent,
        QueueCounterSettingsComponent,
        QuickDateRangeSelectorComponent,
        RaffleRewardsDetailsComponent,
        RecordingsLandingComponent,
        RecordingsDetailsComponent,
        FormDisplayComponent,
        ReleaseModalComponent,
        ReorderBtnRenderedComponent,
        RepeatedSelectorsComponent,
        ReportComponent,
        ReportingSetActionsCellComponent,
        ReportingSetComponent,
        ReportingSetDetailedViewComponent,
        ReportingSetDynamicFiltersComponent,
        ReportingsetDynamicFiltersWrapperComponent,
        ReportingSetSettingsComponent,
        ReportSettingsComponent,
        ResponsiveDashboardComponent,
        RevertPayoutDetailsComponent,
        RewardEstimatorTableComponent,
        ResizeDirective,
        ShadowBoxingPreviewComponent,
        ShadowBoxingProgressComponent,
        SafeUrlPipe,
        SaveDashboardModalComponent,
        ScheduleAdherenceSettingsComponent,
        SelectedDashboardDetailsComponent,
        SelectedUserLabelComponent,
        SendToSubscriptionComponent,
        ServiceLevelComponent,
        ServiceLevelSettingsComponent,
        SettingsSlideoutComponent,
        ScheduleAdherenceComponent,
        ShadowBoxingResultComponent,
        SharedDashboardComponent,
        ShareTextRendererComponent,
        ShareViaUrlComponent,
        ShoppingCartLandingComponent,
        ShoppingCartListComponent,
        SidebarModuleListComponent,
        SingleAttributeSelectorComponent,
        SingleSelectComponent,
        StatusCellRendererComponent,
        SubmitFeedbackComponent,
        SubscriptionManagementComponent,
        SubscriptionManagementEditComponent,
        SubscriptionModalComponent,
        SubscriptionSchedulerComponent,
        SubtotalRenderedComponent,
        SuggestCoachingModalComponent,
        SummaryComboComponent,
        SysTemplateActionCellRendererComponent,
        SystemplateCellRendererComponent,
        SystemplateStatusCellRendererComponent,
        TakeOwnershipComponent,
        TaskbarComponent,
        TeamsHistoryTableComponent,
        TasksComponent,
        TasksModalComponent,
        TemplateListModalComponent,
        ThresholdRangeValidator,
        TimeEntryDirective,
        TimePickerComponent,
        TimeRangeSelectorComponent,
        TimeSliderComponent,
        TopCallTimesComponent,
        TopCallTimesSettingsComponent,
        TopCategoriesComponent,
        TopCategoriesSettingsComponent,
        TrendingComponent,
        TreeBuilderComponent,
        UniquePipe,
        UsageStatsExportButtonComponent,
        UserAdminComponent,
        UserListComponent,
        ViewReasonModalComponent,
        WallboardsAssignComponent,
        WallboardsComponent,
        WarningDialogComponent,
        WebhelpETSComponent,
        WebhelpETSSettingsComponent,
        AgentOrderHistoryComponent,
        CvNumberLocalizePipe,
        ShoppingCartListComponent,
        ShoppingCartLandingComponent,
        ListFilterPipe,
        DeleteBtnRenderedComponent,
        QtyInputRenderedComponent,
        ReorderBtnRenderedComponent,
        GridTemplateComponent,
        CxoneContactStateDescriptionsSelectorComponent,
        CvMarketplaceShoppingCartComponent,
        WallboardColumnSortSelectorComponent,
        WallboardViewCustomImageComponent,
        WallboardViewCustomTextComponent,
        WallboardViewCustomAchievementComponent,
        WallboardViewCustomSummaryComponent,
        WallboardViewCustomThermometerComponent,
        WallboardViewCustomGaugeComponent,
        WallboardViewCustomTopComponent,
        WallboardViewCustomAgentCounterComponent,
        WallboardViewCustomKpiComponent,
        WallboardViewCurrentAgentStatesComponent,
        WallboardViewCurrentAgentStatesResponsiveComponent,
        WallboardViewGamesComponent,
        WallboardViewImageComponent,
        WallboardViewLeaderboardComponent,
        WallboardViewMainComponent,
        WallboardViewMarketplaceComponent,
        WallboardViewRacingComponent,
        WallboardViewScorecardComponent,
        WallboardViewSpotlightComponent,
        WallboardViewSummaryComponent,
        WallboardViewChallengesComponent,
        WallboardViewCustomComponent,
        StartOnPipe,
        LimitToPipe,
        OrderByPipe,
        NumberLocalizePipe,
        WallboardViewVideoComponent,
        WidgetAccessCellRendererComponent,
        WidgetThresholdsModalComponent,
        WorkAidsComponent,
        WorkAidsNewComponent,
        WorkspaceLandingComponent,
        WorkspaceNewTabLandingComponent
    ],
    imports: [
        AddEntityModule,
        AgGridModule,
        AccordionModule,
        BrowserAnimationsModule,
        BrowserModule,
        ButtonMenuSolModule,
        CheckboxModule,
        CheckboxSolModule,
        ClipboardModule,
        ColorPickerModule,
        DateTimePickersModule,
        DateRangepickerModule,
        DatepickerModule,
        DragDropModule,
        DropdownModule,
        DynamicDialogModule,
        EditorModule,
        EmbeddedMessagesModule,
        FormsModule,
        FloatingMenuModule,
        GridModule,
        GridSolModule,
        DropdownSolModule,
        DatepickerSolModule,
        RadioSolModule,
        NumericSelectorSolModule,
        ButtonSolModule,
        GridsterModule,
        HighchartsChartModule,
        HttpClientModule,
        ImageCropperModule,
        InlineNotificationModule,
        MatCheckboxModule,
        MatChipsModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatStepperModule,
        MatTooltipModule,
        ModalModule,
        MultiselectDropdownModule,
        NgbModule,
        NgChartsModule,
        NouisliderModule,
        NumericSelectorModule,
        OmnibarModule,
        OmnibarSolModule,
        OverlayscrollbarsModule,
        PopoverModule,
        ProgressBarModule,
        QueryBuilderModule,
        RadioModule,
        RangeSliderModule,
        ReactiveFormsModule,
        ScrollingModule,
        SelectedTagsModule,
        SelectedTagsSolModule,
        SingleselectDropdownModule,
        SlideToggleModule,
        SlideToggleSolModule,
        SolButtonToggleGroupModule,
        SolCardModule,
        SolChipModule,
        SolStatusIndicatorModule,
        SolTabsModule,
        SolTooltipModule,
        SpinnerModule,
        SvgSpriteIconModule,
        TabsModule,
        TagifyModule,
        TextAreaModule,
        TextInputModule,
        SolTextInput,
        ToastrManagerModule,
        ToastrManagerSolModule,
        ToggleButtonGroupModule,
        TooltipModule,
    ],
    providers: [
        [CVApiService],
        { provide: "$window", useFactory: () => window },
        { provide: WINDOW_INJECTION_TOKEN, useValue: window },
        { provide: "$document", useFactory: () => document },
        { provide: ConfigurationCoreService, useClass: ConfigurationCoreService },
        { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [I18NEXT_SERVICE] },
        {
            provide: LocalizationInitializer, useClass: LocalizationInitializer,
            deps: [I18NEXT_SERVICE, HttpClient, ConfigurationCoreService]
        },
        {
            provide: APP_INITIALIZER, multi: true, useFactory: AppInitializerFactory,
            deps: [I18NEXT_SERVICE, LocalizationInitializer, ConfigurationCoreService, CVApiService]
        },
        [ConfigurationService],
        AnalyticsService,
        ArraySortPipe,
        AssignBoxPipe,
        BoldTextPipe,
        CustomMetricFormatterPipe,
        CvNumberLocalizePipe,
        CvOrdinalLocalizePipe,
        DatePipe,
        DecimalPipe,
        DialogService,
        EncodeColorPipe,
        FilesizeformatPipe,
        FilterTextPipe,
        FormatNumericTypePipe,
        GamesFilterPipe,
        GenericMetricFormatterPipe,
        ProductsFilterPipe,
        ThresholdRangeValidator,
    ],
    bootstrap: []
})
export class AppModule implements DoBootstrap {
    /** List of custom elements to export (sort alphabetically) */
    private elements: any[] = [
        [AboutComponent, 'about'],
        [AcdCallbackComponent, 'cvAcdCallback'],
        [AddCustomHierarchyComponent, 'addCustomHierarchy'],
        [AddEditAssignBoxComponent, 'addEditAssignBox'],
        [AgentOrderHistoryComponent, 'agentOrderHistory'],
        [AgentStateSummaryComponent, 'cvAgentStateSummary'],
        [AgGridIChartTemplateComponent, 'agGridIchartTemplate'],
        [AngularAssignToolComponent, 'cvAngularAssignToolAngular'],
        [AnnouncementsComponent, 'announcementsAdmin'],
        [AnnouncementsNewComponent, 'announcementsNew'],
        [AttributeSelectorComponent, 'attributeSelector'],
        [AwardCardComponent, 'awardCard'],
        [AwardsExportButtonComponent, 'awardsExportButton'], // access to this component as generic-export
        [AwardsHistoryListComponent,'awardsHistoryList'],
        [AwardsCardMenuComponent,'awardsCardMenu'],
        [AwardsLandingComponent,'awardsLanding'],
        [AwardsAddEditComponent,'awardsAddEdit'],
        [AwardedPopupComponent,'awardedPopup'],
        [BadgesEarnedComponent, 'badgesEarned'],
        [BadgeSelectorComponent, 'badgeSelector'],
        [BANCOITAUComponent, 'cvBancoItau'],
        [BaremetricsCalendarComponent, 'baremetricsCalendar'],
        [BattleBoatChallengeComponent, 'battleBoatChallenge'],
        [BattleBoatDetailsComponent, 'battleBoatDetails'],
        [BattleBoatShotComponent, 'battleBoatShot'],
        [BracketViewComponent, 'bracketView'],
        [BroadcastDetailsComponent, 'broadcastDetails'],
        [BroadcastAssignComponent, 'broadcastAssign'],
        [BudgetExportButtonComponent,'budgetExportButton'],
        [CalculatorComponent, 'calculator'],
        [ChallengeCardViewComponent, 'challengeCardView'],
        [ChallengeBattleBoatResultComponent, 'challengeBattleBoatResult'],
        [ChallengedUsersModalComponent, 'challengedUsersModal'],
        [ChallengesHistoryComponent, 'challengesHistory'],
        [ChallengesListComponent, 'challengesList'],
        [ChallengesSettingsComponent, 'challengesSettings'],
        [CoinHistoryComponent, 'coinHistory'],
        [CoinsEarnedComponent, 'coinsEarned'],
        [CommandCenterComponent, 'commandCenter'],
        [CommandCenterGroupSelectorComponent, 'commandCenterGroupSelector'],
        [CommandCenterOnboardingComponent, 'commandCenterOnboarding'],
        [CompanySettingsComponent, 'cvCompanySettings'],
        [ConfigureBoardConnect3Component, 'configureBoardConnect3'],
        [ConfigureBoardMilestoneComponent, 'configureBoardMilestone'],
        [ConfigureEligibilityBracketsComponent, 'configureEligibilityBrackets'],
        [ConfigureEligibilityComponent, 'configureEligibility'],
        [ConfigureEstimatorComponent, 'configureEstimator'],
        [ConfigureEstimatorPopupComponent, 'configureEstimatorPopup'],
        [ConfigureFoldersComponent, 'configureFolders'],
        [ConfigureMetricComponent, 'configureMetric'],
        [ConfigureNameComponent, 'configureName'],
        [ConfigureQualifierComponent, 'configureQualifier'],
        [ConfigureRewardsBracketsComponent, 'configureRewardsBracketsTournament'],
        [ConfigureRewardsBullseyeComponent, 'configureRewardsBullseye'],
        [ConfigureRewardsConnect3Component, 'configureRewardsConnect3'],
        [ConfigureRewardsMilestoneComponent, 'configureRewardsMilestone'],
        [ConfigureRewardsMultiplierComponent, 'configureRewardsMultiplier'],
        [ConfigureRewardsRaffleComponent, 'configureRewardsRaffle'],
        [ConfigureRewardsTopDogComponent, 'configureRewardsTopDog'],
        [ConfigureScheduleComponent, 'configureSchedule'],
        [ConfigureScheduleBracketsComponent, 'configureScheduleBrackets'],
        [ContextMenuAwardsDialogComponent, 'contextMenuAwardsDialog'],
        [Connect3MetricPopupComponent, 'connect3MetricPopup'],
        [CreateNewDashboardComponent, 'dashboardCreateNew'],
        [CurrencyPendingExportButtonComponent, 'pendingExportButton'],
        [CustomBadgeCreatorComponent, 'customBadgeCreator'],
        [CustomDialogComponent, 'customDialog'],
        [CVGaugeComponent, 'gauge'],
        [CvLoaderComponent, 'cvLoader'],
        [CvMarketplaceCartDrawerComponent, 'cvMarketplateCartDrawer'],
        [CvMarketplaceShoppingCartComponent, 'cvMarketplaceShoppingCart'],
        [CvMarketplaceShoppingCartOrdersComponent, 'cvMarketplaceShoppingCartOrders'],
        [CvMarketplaceShoppingCartProductDetailsComponent, 'cvMarketplaceShoppingCartProductDetails'],
        [CvMarketplaceShoppingCartWishlistComponent, 'cvMarketplaceShoppingCartWishlist'],
        [CvPointStoreNewEditProductComponent, 'cvPointStoreNewEditProduct'],
        [CvPointStoreProductAssignmentCxoneComponent, 'cvPointStoreProductAssignmentCxone'],
        [CvPointStoreProductInformationCxoneComponent, 'cvPointStoreProductInformationCxone'],
        [CvPointStoreProductSettingCxoneComponent, 'cvPointStoreProductSettingCxone'],
        [CvPointStoreProductSummaryCxoneComponent, 'cvPointStoreProductSummaryCxone'],
        [CvPointStoreProductUploadCxoneComponent, 'cvPointStoreProductUploadCxone'],
        [CvAdminLandingComponent, 'adminLanding'],
        [CXOneAddWidgetComponent, 'cvCXOneAddWidget'],
        [CxoneCustomDataImportComponent, 'cxoneCustomDataImport'],
        [CxoneDashboardContentComponent, 'cvCxoneDashboardContent'],
        [CXOneDashboardHeaderComponent, 'cvDashboardHeader'],
        [CxoneEmptyWorkspaceComponent, 'cvCxoneEmptyWorkSpace'],
        [CxoneEtlDataFeedComponent, 'cxoneEtlDataFeed'],
        [CxoneEtlDataFeedViewComponent, 'cxoneDataFeedView'],
        [CxoneEtlDataRecalculationComponent, 'cxoneEtlDataRecalculation'],
        [CxoneEtlReportingSetComponent, 'cxoneReportingSetDefinitions'],
        [CXOneFirstPhaseIntegrationComponent, 'cvCxoneFirstPhaseIntegration'],
        [CXoneGaugeComponent, 'cvCxoneGauge'],
        [CxoneManageMetricsComponent, 'cvCxoneManageMetrics'],
        [CxoneObjectivesComponent, 'cvCxoneObjectives'],
        [CxoneOrderPlacedComponent, 'cvCxoneOrderPlaced'],
        [CxoneAwardModalComponent, 'cvCxoneAwardModal'],
        [CxoneSelectAwardCardComponent, 'cvCxoneSelectAwardCard'],
        [CxoneWallboardsComponent, 'cvCxoneWallboards'],
        [DashboardAccessComponent, 'cvDashboardAccess'],
        [DashboardFilterSlideoutComponent, 'dashboardFilterSlideout'],
        [DashboardProjectionContentComponent, 'dashboardProjectionContent'],
        [DashboardWindowComponent, 'dashboard-window'],
        [DateRangeSelectorComponent, 'dateRangeSelector'],
        [DispositionsComponent, 'dispositions'],
        [DowSelectorComponent, 'dowSelector'],
        [EvaluatorCalibrationComponent, 'cv-evaluator-calibration'],
        [ExpandedSummaryComponent, 'cvExpandedSummary'],
        [ExpandedSummarySettingsComponent, 'cvExpandedSummaryInternalSettings'],
        [ExtendedKpiComponent, 'extendedKpi'],
        [FormsCalibrationComponent, 'cv-forms-calibration'],
        [FormsComponent, 'forms'],
        [GainsightInjectorComponent, 'gainsightInjector'],
        [GamesAddEditComponent, 'gamesAddEdit'],
        [GamesConfigureComponent, 'gamesAddEditConfigure'],
        [GamesDetailsModalComponent, 'gamesDetailsModal'],
        [GameHistoryBreakdownEffectivenessComponent, 'gameHistoryBreakdownEffectiveness'],
        [GamesHistoryComponent, 'gamesHistory'],
        [GamesHistoryTableComponent, 'gamesHistoryTable'],
        [GamesHistoryHealthReportComponent, 'gamesHistoryHealthReport'],
        [GamesLandingComponent, 'gamesLanding'],
        [GamesRunningByTypeComponent, 'gamesRunningByType'],
        [GamesRunningModalComponent, 'gamesRunningModal'],
        [GamificationExportComponent, 'gamificationExport'],
        [GiveAwardPopupComponent, 'giveAwardPopup'],
        [GroupSelectorComponent, 'groupSelector'],
        [HealthReportExportButtonComponent, 'healthReportButtonExport'],
        [HealthReportSpecificDetailsComponent, 'healthReportSpecificDetails'],
        [HealthReportTopPerformersComponent, 'healthReportTopPerformers'],
        [IaFrustrationComponent, 'cv-ia-frustration'],
        [IntegrationMongoLogsComponent, 'integrationMongoLogs'],
        [IntervalComboComponent, 'intervalCombo'],
        [IntervalComboSettingsComponent, 'intervalComboSettings'],
        [KpiComponent, 'widget'],
        [LaunchCXOneDashAdminComponent, 'cvLaunchCxoneDashAdmin'],
        [LaunchWallboardComponent, 'cvLaunchWallboard'],
        [LeaderboardComponent, 'ranking'],
        [LinkedContactsComponent, 'cvLinkedContacts'],
        [LoginLogoutComponent, 'loginLogout'],
        [ManageAvailableDashboardsComponent, 'manageAvailableDashboards'],
        [ManageReportsComponent, 'managereports'],
        [MarketplaceOrdersModalComponent, 'marketplaceOrdersModal'],
        [MarketplaceOrdersTableComponent, 'marketplaceOrdersTable'],
        [MarketplaceOverviewComponent, 'marketplaceOverview'],
        [MarketplaceProductsModalComponent, 'marketplaceProductModal'],
        [MetricDefinitionsLandingComponent, 'metricDefinitionsLanding'],
        [CxoneOrderManagementComponent, 'cxoneOrderManagement'],
        [MetricReviewComponent, 'metricReview'],
        [MilestoneBadgesRendererComponent, 'milestoneBadgesRenderer'],
        [MilestoneResultsRendererComponent, 'milestoneResultsRenderer'],
        [ModuleContainerComponent, 'moduleContainer'],
        [ModuleErrorComponent, 'moduleError'],
        [ModulePreviewComponent, 'modulePreview'],
        [NavigationHeaderMenuComponent, 'navigationHeaderMenu'],
        [NgTemplateComponent, 'ts-template'],
        [ObjectiveLandingComponent, 'cvObjectiveLanding'],
        [PickGameTypeComponent, 'pickGameType'],
        [PointStoreEditComponent, 'pointStoreEdit'],
        [PointStoreNavigationBarComponent, 'pointStoreNavigationBar'],
        [PointStoreOrdersAdminComponent, 'pointStoreOrdersAdminComponent'],
        [PointStoreProductAssignmentComponent, 'pointStoreProductAssignment'],
        [PointStoreProductInformationComponent, 'pointStoreProductInformation'],
        [PointStoreProductLandingListComponent, 'pointStoreProductLandingList'],
        [PointStoreProductLandingPageComponent, 'pointStoreProductLandingPage'],
        [PointStoreProductLandingThumbnailComponent, 'pointStoreProductLandingThumbnail'],
        [PointStoreProductSettingComponent, 'pointStoreProductSetting'],
        [PointStoreProductSummaryComponent, 'pointStoreProductSummary'],
        [PointStoreProductUploadComponent, 'pointStoreProductUpload'],
        [PublishBarComponent, 'publishBar'],
        [QmEvaluatorPerformanceComparisonComponent, 'cv-qm-evaluator-performance-comparison'],
        [QmEvaluatorPerformanceTrendComponent, 'cv-qm-evaluator-performance-trend'],
        [QueueCounterComponent, 'queueCounter'],
        [RecordingsLandingComponent, 'recordingsLandingMain'],
        [RaffleRewardsDetailsComponent, 'raffle-rewards-details'],
        [ReleaseModalComponent, 'releaseModal'],
        [ReportComponent, 'cv-report'],
        [ReportingSetComponent, 'reportingSetModule'],
        [ResponsiveDashboardComponent, 'responsiveDashboard'],
        [RevertPayoutDetailsComponent, 'revertPayoutDetails'],
        [RewardEstimatorTableComponent, 'rewardEstimatorTable'],
        [SaveDashboardModalComponent, 'cvSaveDashboardModal'],
        [SelectedDashboardDetailsComponent, 'selectedDashboardsDetails'],
        [ShadowBoxingPreviewComponent, 'shadowBoxingPreview'],
        [ShadowBoxingProgressComponent, 'shadowBoxingProgress'],
        [SelectedUserLabelComponent, 'selectedUserLabel'],
        [SettingsSlideoutComponent, 'settingsSlideout'],
        [ShadowBoxingResultComponent, 'shadowBoxingResult'],
        [SharedDashboardComponent, 'cvSharedDashboard'],
        [ShareViaUrlComponent, 'cvShareViaUrl'],
        [ShoppingCartLandingComponent, 'shoppingCartLanding'],
        [ShoppingCartListComponent, 'shoppingCartList'],
        [SidebarModuleListComponent, 'sidebarModuleList'],
        [SubscriptionManagementComponent, 'subscriptionManagement'],
        [SubscriptionModalComponent, 'cvSubscriptionModal'],
        [SubscriptionSchedulerComponent, 'cvSubscriptionScheduler'],
        [SummaryComboComponent, 'summaryCombo'],
        [TakeOwnershipComponent, 'cvTakeOwnership'],
        [TaskbarComponent, 'moduleTaskbar'],
        [TeamsHistoryTableComponent, 'teamsHistoryTable'],
        [TimeSliderComponent, 'timeSlider'],
        [TopCallTimesComponent, 'topCallTime'],
        [TopCategoriesComponent, 'cv-top-categories'],
        [UsageStatsExportButtonComponent, 'usageStatsExportButton'], // access to this component as generic-export
        [UserAdminComponent, 'usersList'],
        [WallboardsComponent, 'wallboards'],
        [WallboardViewMainComponent, 'wallboardViewMain'],
        [WorkAidsComponent, 'workAidsAdmin'],
        [WorkAidsNewComponent, 'workAidsNew'],
        [WorkspaceLandingComponent, 'cvWorkspaceLanding'],
        [WorkspaceNewTabLandingComponent, 'workspaceNewTab'],
    ];

    /** List of dashboard modules (sort automatically) */
    /** If a module has export/subscribe it still needs to be in the elements array */
    private modules: any[] = [
        [AcdCallbackComponent, 'cv-acd-callback'],
        [AgentCounterComponent, 'agent-counter'],
        [AgentStateSummaryComponent, 'cv-agent-state-summary'],
        [BANCOITAUComponent, 'cv-banco-itau'],
        [CalculatorComponent, 'calculator'],
        [CalculatedMetricBreakdownComponent, 'calculated-metric-breakdown'],
        [CallArrivalComponent, 'call-arrival'],
        [CategoryOverTimeComponent, 'cv-category-over-time'],
        [CoachingEffectivenessComponent, 'coaching-effectiveness'],
        [CoachingStatusComponent, 'coaching-status'],
        [ContactListComponent, 'contact-list'],
        [ContactStatesSkillComponent, 'cv-contact-states-skill'],
        [CurrentAgentStatesComponent, 'current-agent-states'],
        [CurrentAgentStatesPmComponent, 'current-agent-states-pm'],
        [CurrentAgentStatesCxoneComponent, 'current-agent-states-cxone'],
        [CVGaugeComponent, 'gauge'],
        [CxoneAgentCardComponent, 'cxone-agent-card'],
        [CXOneCallArrivalComponent, 'cxone-call-arrival'],
        [CxoneChallengesComponent, 'cxone-challenges'],
        [CxoneDispositionsComponent, 'cxone-dispositions'],
        [CxoneEvaluationCoachingTrendComponent, 'cxone-evaluation-coaching-trend'],
        [CxoneGameCardComponent, 'cxone-game-card'],
        [CxoneGameMultiplierMadnessComponent, 'cxone-game-multiplier-madness'],
        [CxoneGamesComponent, 'cxone-games'],
        [CxoneGamesTrackerComponent, 'cxone-games-tracker'],
        [CxoneGameTopTeamComponent, 'cxone-game-top-team'],
        [CXoneGaugeComponent, 'cxone-gauge'],
        [CxoneKpiTrendComponent, 'cxone-kpi-trend'],
        [CxoneMyRankingComponent, 'cxone-my-ranking'],
        [CxoneSeeMoreComponent, 'cxone-see-more'],
        [DispositionsComponent, 'dispositions'],
        [EvaluatorCalibrationComponent, 'cv-evaluator-calibration'],
        [ExpandedSummaryComponent, 'cv-expanded-summary'],
        [ExtendedKpiComponent, 'extended-kpi'],
        [FormsCalibrationComponent, 'cv-forms-calibration'],
        [HeatmapComponent, 'geo-tag-data'],
        [IaFrustrationComponent, 'cv-ia-frustration'],
        [IntervalComboComponent, 'interval-combo'],
        [KpiComponent, 'widget'],
        [KpiTrendCoachingEventsComponent, 'kpi-trend-coaching-events'],
        [LeaderboardComponent, 'ranking'],
        [LinkedContactsComponent, 'cv-linked-contacts'],
        [LoginLogoutComponent, 'login-logout'],
        [MetricReviewComponent, 'metric-review'],
        [MetricsBreakDownComponent, 'cxone-metric-breakdown'],
        [MyRankingComponent, 'cv-my-ranking'],
        [NgTemplateComponent, 'ts-template'],
        [NotepadComponent, 'notepad'],
        [PlansStatusComponent, 'plans-status'],
        [QmEvaluationsCoachingComponent, 'cv-qm-evaluations-coaching'],
        [QmEvaluatorPerformanceComponent, 'cv-qm-evaluator-performance'],
        [QualityScoreComponent, 'cv-quality-score'],
        [QueueCounterComponent, 'queue-counter'],
        [ReportComponent, 'cv-report'],
        [ReportingSetComponent, 'reporting-set-module'],
        [ServiceLevelComponent, 'service-level'],
        [ScheduleAdherenceComponent, 'cv-schedule-adherence'],
        [SummaryComboComponent, 'summary-combo'],
        [TasksComponent, 'tasks'],
        [TopCallTimesComponent, 'top-call-time'],
        [TopCategoriesComponent, 'cv-top-categories'],
        [TrendingComponent, 'trending'],
        [WebhelpETSComponent, 'cv-webhelp-custom'],
    ];

    /** List of dashboard modules settings (sort automatically) */
    private moduleSettings: any[] = [
        [AgentCounterSettingsComponent, 'agent-counter-settings'],
        [AgentStateSummarySettingsComponent, 'cv-agent-state-summary-settings'],
        [CallArrivalSettingsComponent, 'call-arrival-settings'],
        [CalculatedMetricBreakdownSettingsComponent, 'calculated-metric-breakdown-settings'],
        [CategoryOverTimeSettingsComponent, 'cv-category-over-time-settings'],
        [CoachingStatusSettingsComponent, 'coaching-status-settings'],
        [ContactListSettingsComponent, 'contact-list-settings'],
        [ContactStatesSkillSettingsComponent, 'cv-contact-states-skill-settings'],
        [CurrentAgentStatesSettingsComponent, 'current-agent-states-settings'],
        [CxoneCallArrivalSettingsComponent, 'cxone-call-arrival-settings'],
        [CXoneEvaluationCoachingTrendSettingsComponent, 'cxone-evaluation-coaching-trend-settings'],
        [EvaluatorCalibrationSettingsComponent, 'cv-evaluator-calibration-settings'],
        [ExpandedSummarySettingsComponent, 'cv-expanded-summary-settings'],
        [FormsCalibrationSettingsComponent, 'cv-forms-calibration-settings'],
        [IaFrustrationSettingsComponent, 'cv-ia-frustration-settings'],
        [IntervalComboSettingsComponent, 'interval-combo-settings'],
        [NgTemplateSettingsComponent, 'ts-template-settings'],
        [PlansStatusSettingsComponent, 'plans-status-settings'],
        [QmEvaluationsCoachingSettingsComponent, 'cv-qm-evaluations-coaching-settings'],
        [QmEvaluatorPerformanceSettingsComponent, 'cv-qm-evaluator-performance-settings'],
        [QualityScoreSettingsComponent, 'cv-quality-score-settings'],
        [QueueCounterSettingsComponent, 'queue-counter-settings'],
        [ReportingSetSettingsComponent, 'reporting-set-module-settings'],
        [ReportSettingsComponent, 'cv-report-settings'],
        [ScheduleAdherenceSettingsComponent, 'cv-schedule-adherence-settings'],
        [ServiceLevelSettingsComponent, 'service-level-settings'],
        [TopCallTimesSettingsComponent, 'top-call-time-settings'],
        [TopCategoriesSettingsComponent, 'cv-top-categories-settings'],
        [WebhelpETSSettingsComponent, 'cv-webhelp-custom-settings'],
    ];

    constructor(
        private injector: Injector,
    ) {

    }

    ngDoBootstrap() {
        // create custom elements
        for (const [component, name] of this.elements) {
            const el = createCustomElement(component, { injector: this.injector });
            const ceName = `${name.toLowerCase()}-ce`;
            customElements.define(ceName, el);

            if (window['angular']) {
                const ng1El = createNg1Wrapper(ceName, component, {
                    injector: this.injector
                });

                angular.module('ClearViewApp').component(name, ng1El);
            }
        }

        // add dashboard modules
        const angularModuleService = new AngularModuleServiceBase(true);
        for (const [component, name] of this.modules) {
            angularModuleService.addAngularModule(name, component);
        }

        for (const [component, name] of this.moduleSettings) {
            angularModuleService.addAngularModuleSettings(name, component);
        }
    }
}
